/* wsapi3-checkout-payment-page v1.0 */
/* Deploy Version 2026-09-24 13:15:23 */
/* Fase 2 — visual reestilizado no formato do checkout de exemplo: tela de
   identificação unificada (e-mail ou CPF/CNPJ + login social) e acordeão de
   4 etapas (Informações pessoais / Endereço / Formas de envio / Pagamento).
   Toda a lógica de negócio original (frete, pagamento, cupom, captcha, ponte
   de tokenização legada) foi preservada — só a disposição visual e a forma
   como o usuário navega entre as seções mudou. Helpers comuns (formatação de
   preço, escape de HTML, ícones de pagamento, parse de ct/ct2, acordeão)
   agora vêm de window.WsCheckoutBase (wsapi3-checkout-base). */
(function () {
    'use strict';

    /* ─────────────────────────────────────────────
       ÍCONES DE PAGAMENTO (superset unificado em WsCheckoutBase)
    ───────────────────────────────────────────── */
    function getPaymentIcon(opt, pm) {
        var key = (opt && opt.sub_type) || (pm && (pm.type || pm.gateway_type)) || '';
        return WsCheckoutBase.paymentIcon(key);
    }

    /* ─────────────────────────────────────────────
       ESTADO
    ───────────────────────────────────────────── */
    var _ct = '';
    var _ct2 = '';
    var _orderNumber = '';
    var _initData = null;
    var _selectedPayment = null;
    var _selectedShipping = null;
    var _identity = null; // { type: 'email'|'cpf_cnpj', value }
    var _needsSignup = false; // true = e-mail/CPF checado não existia; cria a conta (auth/signup) antes do pagamento
    var _addresses = [];       // endereços salvos do cliente (GET /user/data/personal-info/view)
    var _selectedAddressIdx = -1;
    var _recaptchaEnabled = false;
    var _recaptchaWidgetId = null;
    var _loadedScripts = {};
    var _noShipping = false;   // cart.sendable === false: pedido sem nada a entregar — sem etapas de endereço/envio (ver applyNoShippingLayout)

    // Campos que a API pode declarar em option.fields[] (GET /cart/checkout/init)
    // mas que a própria aplicação preenche sozinha — nunca viram input pro
    // cliente digitar. O valor é escrito num hidden HD_<ID_MAIUSCULO>_{fpg_id}
    // pelo script de tokenização do gateway (script_token_url, ver
    // bridgeLegacyFields) e lido de lá no submit (ver doSubmit). Hoje só o
    // Mercado Pago (fpg_id 12) declara payment_method_id, mas o mecanismo é
    // genérico — não checa fpg_id/api_name.
    var AUTO_FILLED_CARD_FIELD_IDS = { payment_method_id: true };

    /* ─────────────────────────────────────────────
       HELPERS (delegam pro base module, mantendo os
       call sites originais deste arquivo intactos)
    ───────────────────────────────────────────── */
    function el(id) { return document.getElementById(id); }

    function show(id) { var e = el(id); if (e) e.style.display = ''; }
    function hide(id) { var e = el(id); if (e) e.style.display = 'none'; }

    // Reveal/collapse animado (max-height via WsCheckoutBase.expand/collapse,
    // ver checkout-base.js/css) — usado nos blocos que aparecem/desaparecem
    // dentro do próprio fluxo (cupom, observação, campos de cartão, botão
    // finalizar, alternância lista/formulário de endereço), ao contrário de
    // show/hide acima (display:none, sem transição).
    function openCollapse(id, onDone) { WsCheckoutBase.expand(el(id), onDone); }
    function closeCollapse(id) { WsCheckoutBase.collapse(el(id)); }

    // Overlay de recarregamento padrão do site (mesmo spinner/blur de produto,
    // área do cliente, carrinho etc. — ver wsMain.tools.showLoading() em
    // wsapi3-main.js/.css). Mantidos como showOverlay/hideOverlay aqui só pra
    // não precisar tocar cada chamada espalhada pelo arquivo.
    function showOverlay() { wsMain.tools.showLoading(); }
    function hideOverlay() { wsMain.tools.hideLoading(); }

    function fmtPrice(val) { return WsCheckoutBase.fmtPrice(val); }
    function escHtml(str) { return WsCheckoutBase.escHtml(str); }

    // "CORREIOS - SEDEX" -> "Correios - Sedex". Só age quando o texto vem TODO
    // em maiúsculo (transportadora/serviço cadastrado assim na loja) — se já
    // vier em caixa mista ("LOGGI Standard"), devolve igual, sem tocar.
    function titleCaseIfAllCaps(str) {
        var s = String(str || '');
        if (s !== s.toUpperCase() || s === s.toLowerCase()) return s;
        return s.toLowerCase().replace(/(^|[\s\-\/])([a-zà-ÿ])/g, function (m, sep, ch) {
            return sep + ch.toUpperCase();
        });
    }

    // Só dígitos até 11 caracteres = ainda pode ser CPF, formata como tal.
    // A partir do 12º caractere (ou assim que aparece uma letra, já que CPF
    // nunca tem letra) passa a formatar como CNPJ — 12 primeiros caracteres
    // alfanuméricos (novo CNPJ alfanumérico da Receita Federal, Nota Técnica
    // COCAD/RFB nº 33/2024), os 2 dígitos verificadores finais continuam só
    // numéricos — e trava em 14 caracteres no total (antes disso o campo
    // aceitava dígitos sem limite nenhum).
    function onlyCpfCnpjChars(val) {
        return String(val || '').toUpperCase().replace(/[^0-9A-Z]/g, '');
    }

    function fmtCpf(val) {
        var raw = onlyCpfCnpjChars(val);

        if (!/[A-Z]/.test(raw) && raw.length <= 11) {
            var d = raw;
            if (d.length > 9) return d.slice(0,3) + '.' + d.slice(3,6) + '.' + d.slice(6,9) + '-' + d.slice(9);
            if (d.length > 6) return d.slice(0,3) + '.' + d.slice(3,6) + '.' + d.slice(6);
            if (d.length > 3) return d.slice(0,3) + '.' + d.slice(3);
            return d;
        }

        var root = raw.slice(0, 12);
        var dv    = raw.slice(12, 14).replace(/[^0-9]/g, '');
        var c     = root + dv;
        if (c.length > 12) return c.slice(0,2) + '.' + c.slice(2,5) + '.' + c.slice(5,8) + '/' + c.slice(8,12) + '-' + c.slice(12);
        if (c.length > 8)  return c.slice(0,2) + '.' + c.slice(2,5) + '.' + c.slice(5,8) + '/' + c.slice(8);
        if (c.length > 5)  return c.slice(0,2) + '.' + c.slice(2,5) + '.' + c.slice(5);
        if (c.length > 2)  return c.slice(0,2) + '.' + c.slice(2);
        return c;
    }

    // Dígito verificador mod-11 padrão (CPF e CNPJ tradicional/alfanumérico
    // usam o mesmo cálculo, só mudam os pesos e como cada caractere vira
    // valor numérico).
    function calcCheckDigit(values, weights) {
        var sum = 0;
        for (var i = 0; i < weights.length; i++) sum += values[i] * weights[i];
        var rest = sum % 11;
        return rest < 2 ? 0 : 11 - rest;
    }

    function isValidCpf(digits) {
        if (digits.length !== 11 || /^(\d)\1{10}$/.test(digits)) return false; // todos os dígitos iguais sempre "passa" no cálculo, mas nunca é um CPF real
        var n = digits.split('').map(Number);
        if (calcCheckDigit(n.slice(0, 9), [10,9,8,7,6,5,4,3,2]) !== n[9]) return false;
        return calcCheckDigit(n.slice(0, 10), [11,10,9,8,7,6,5,4,3,2]) === n[10];
    }

    // CNPJ (inclusive o novo alfanumérico): cada caractere vira valor via
    // charCodeAt(0)-48 — dígitos '0'-'9' -> 0-9 (igual sempre foi), letras
    // 'A'-'Z' -> 17-42. Os 2 dígitos verificadores finais são sempre
    // numéricos, então continuam valendo 0-9 puro na comparação final.
    function isValidCnpj(value) {
        if (!/^[0-9A-Z]{12}\d{2}$/.test(value)) return false;
        var v = value.split('').map(function (ch) { return ch.charCodeAt(0) - 48; });
        if (calcCheckDigit(v.slice(0, 12), [5,4,3,2,9,8,7,6,5,4,3,2]) !== v[12]) return false;
        return calcCheckDigit(v.slice(0, 13), [6,5,4,3,2,9,8,7,6,5,4,3,2]) === v[13];
    }

    function isValidCpfCnpj(value) {
        var v = onlyCpfCnpjChars(value);
        if (v.length === 11) return isValidCpf(v);
        if (v.length === 14) return isValidCnpj(v);
        return false;
    }

    function fmtCep(val) {
        var d = String(val || '').replace(/\D/g, '');
        if (d.length > 5) return d.slice(0, 5) + '-' + d.slice(5, 8);
        return d;
    }

    function cleanCep(val) { return String(val || '').replace(/\D/g, ''); }
    function normZip(zip) { return String(zip || '').replace(/\D/g, ''); }

    function fmtBusinessDays(n) {
        n = Number(n) || 0;
        return n + (n === 1 ? ' dia útil' : ' dias úteis');
    }
    function onlyDigits(v) { return String(v || '').replace(/\D/g, ''); }

    function setMsg(id, text, type) {
        var div = el(id);
        if (!div) return;
        div.textContent = text || '';
        div.className = 'wscb-msg' + (type ? ' wscb-msg--' + type : '');
    }

    function setField(id, value) {
        var inp = el(id);
        if (inp && value) inp.value = value;
    }

    /* ── Erro por campo (borda vermelha + mensagem abaixo do campo) ──────
       Usado na etapa "Informações pessoais": em vez de uma mensagem única no
       rodapé do bloco (que não sinalizava qual campo estava errado e só
       mostrava o primeiro erro da fila), cada campo com problema ganha a
       classe .wscb-invalid e uma .wscb-msg--error logo abaixo dele. */
    function setFieldError(id, message) {
        var inp = el(id);
        if (!inp) return;
        inp.classList.add('wscb-invalid');
        var field = inp.closest('.wscb-field');
        if (!field) return;
        var msgEl = field.querySelector('.ws-checkout-init-field-error');
        if (!msgEl) {
            msgEl = document.createElement('div');
            msgEl.className = 'wscb-msg wscb-msg--error ws-checkout-init-field-error';
            field.appendChild(msgEl);
        }
        msgEl.textContent = message;
    }

    function clearFieldError(id) {
        var inp = el(id);
        if (!inp) return;
        inp.classList.remove('wscb-invalid');
        var field = inp.closest('.wscb-field');
        if (!field) return;
        var msgEl = field.querySelector('.ws-checkout-init-field-error');
        if (msgEl) msgEl.remove();
    }

    var PERSONAL_FIELD_IDS = [
        'ws-checkout-init-p-email', 'ws-checkout-init-p-cpf', 'ws-checkout-init-p-name',
        'ws-checkout-init-p-contact', 'ws-checkout-init-p-mobile', 'ws-checkout-init-p-birth',
        'ws-checkout-init-p-password', 'ws-checkout-init-p-gender'
    ];
    function clearAllPersonalFieldErrors() {
        PERSONAL_FIELD_IDS.forEach(clearFieldError);
    }

    function accordionContainer() {
        return document.querySelector('.ws-checkout-init-main');
    }

    /* ─────────────────────────────────────────────
       BLOQUEIO PROGRESSIVO DO ACORDEÃO
       Etapas futuras (ainda não alcançadas) ficam com header clicável, mas o
       clique só mostra um aviso — nada abre. _unlockedUpTo é o índice mais
       alto já liberado em STEP_ORDER; sobe só pra frente (Math.max), nunca
       desce — reabrir uma etapa anterior pra revisar/editar (ver
       doSignupThenProceed voltando pra "personal") não deve bloquear as
       etapas já visitadas depois dela.
    ───────────────────────────────────────────── */
    var STEP_ORDER = ['personal', 'address', 'shipping', 'payment'];
    var STEP_LABELS = {
        personal: 'Informações pessoais',
        address:  'Endereço de entrega',
        shipping: 'Formas de envio',
        payment:  'Pagamento'
    };
    var _unlockedUpTo = 0; // índice em STEP_ORDER — só "personal" liberada de início

    function refreshStepLocks() {
        var container = accordionContainer();
        if (!container) return;
        STEP_ORDER.forEach(function (name, idx) {
            var stepEl = container.querySelector('.wscb-step[data-step="' + name + '"]');
            if (!stepEl) return;
            // idx > _unlockedUpTo  → ainda bloqueada
            // idx < _unlockedUpTo  → já concluída (mostra o "check" ao lado do lápis)
            // idx === _unlockedUpTo → é a etapa em aberto agora
            stepEl.classList.toggle('wscb-step--locked', idx > _unlockedUpTo);
            stepEl.classList.toggle('wscb-step--done', idx < _unlockedUpTo);
        });
    }

    // Chamar quando uma etapa é concluída (nunca pra "voltar" — nesse caso use
    // WsCheckoutBase.openStep direto, sem passar por aqui).
    function advanceToStep(stepName) {
        // Pedido sem frete: quem pedir "address"/"shipping" (fim da etapa 1,
        // em vários pontos do fluxo) cai direto no pagamento.
        if (_noShipping && (stepName === 'address' || stepName === 'shipping')) stepName = 'payment';
        var idx = STEP_ORDER.indexOf(stepName);
        if (idx > _unlockedUpTo) {
            _unlockedUpTo = idx;
            refreshStepLocks();
        }
        WsCheckoutBase.openStep(accordionContainer(), stepName);
    }

    /* Pedido sem produto que precise de frete (cart.sendable === false, mesmo
       campo que o carrinho lateral e o /carrinho usam pra esconder o cálculo
       de frete): some com as etapas "Endereço de entrega" e "Formas de envio"
       — fica só Informações pessoais → Pagamento. STEP_ORDER é reduzido pra
       que _unlockedUpTo/refreshStepLocks e o aviso de "conclua a etapa X"
       continuem batendo com o que está na tela. */
    function applyNoShippingLayout() {
        STEP_ORDER = ['personal', 'payment'];
        var container = accordionContainer();
        if (container) {
            container.classList.add('ws-checkout-init--no-shipping');
            ['address', 'shipping'].forEach(function (name) {
                var stepEl = container.querySelector('.wscb-step[data-step="' + name + '"]');
                if (stepEl) stepEl.style.display = 'none';
            });
        }
        ['ws-checkout-init-p-continue', 'ws-checkout-init-p-save'].forEach(function (id) {
            var b = el(id);
            if (b) b.textContent = 'Continuar para pagamento';
        });
    }

    /* ─────────────────────────────────────────────
       SUB-ETAPA DO HEADER (barra de progresso)
       #HdEtapaLoja já vem do servidor como "FORMAS_PAGAMENTO" (67%), o que
       faz o header (wsapi3-checkout-header.js) marcar Carrinho E
       Identificação como concluídos (✓) assim que a página carrega — mesmo
       quando o cliente ainda está na tela de identificação, sem login. Aqui
       setamos #HdSubEtapaLoja (que o header já sabe ler como override) para
       corrigir isso: "IDENTIFICACAO" enquanto o guest não logou, limpo (volta
       a 67%) assim que a etapa de pagamento é exibida.
    ───────────────────────────────────────────── */
    function setHeaderSubStage(value) {
        var inp = document.getElementById('HdSubEtapaLoja');
        if (!inp) {
            inp = document.createElement('input');
            inp.type = 'hidden';
            inp.id = 'HdSubEtapaLoja';
            document.body.appendChild(inp);
        }
        inp.value = value || '';
        try {
            var headerModule = typeof wsMain !== 'undefined' && wsMain.modules && wsMain.modules['checkout-cart-header'];
            if (headerModule) headerModule.subFunctions.progressBar();
        } catch (e) { }
    }

    /* ─────────────────────────────────────────────
       PARSE DE URL PARAMS
    ───────────────────────────────────────────── */
    function parseParams() {
        var p = WsCheckoutBase.parseCheckoutParams();
        _ct = p.ct;
        _ct2 = p.ct2;
        _orderNumber = p.orderNumber;
    }

    function buildReturnUrl() {
        return window.location.pathname + window.location.search;
    }

    /* ─────────────────────────────────────────────
       ViaCEP para auto-preenchimento
    ───────────────────────────────────────────── */
    async function fetchViaCep(cep) {
        try {
            var r = await fetch('https://viacep.com.br/ws/' + cleanCep(cep) + '/json/');
            return await r.json();
        } catch (e) {
            return null;
        }
    }

    /* ─────────────────────────────────────────────
       TELA DE IDENTIFICAÇÃO — campo único (e-mail ou CPF/CNPJ) + login social
       (Google/Facebook). Lógica em si vem de wsapi3-identify-flow
       (compartilhada com wsapi3-login-page e wsapi3-login-sidebar) — aqui só
       ficam os seletores desta tela e o que é particular do checkout: e-mail
       novo continua pro acordeão em vez de /cadastro (a conta só é criada de
       fato — /auth/signup — no clique de "Finalizar compra", ver
       doSignupThenProceed), login (senha ou social) recarrega o próprio
       checkout em vez de redirecionar, e erro de rede na checagem do
       e-mail/CPF manda pro /login em vez de só mostrar mensagem.

       Login social (Google/Facebook) quando o e-mail NÃO existe: socialSignupFallback
       fica ligado, mas ao contrário do login-page (que criaria a conta ali mesmo via
       /cadastro-pass), o checkout NÃO tem como coletar o resto dos dados obrigatórios
       (CPF, celular, data de nascimento, senha, endereço) durante um popup — então
       onSocialSignupResolved só aproveita o e-mail/nome que o Google devolveu e trata
       como se o cliente tivesse digitado esse e-mail no campo (mesma extremidade de
       onIdentityNew): cai no acordeão, formulário de cliente novo, e a conta é criada
       de verdade só no "Finalizar compra", igual qualquer outro cliente novo.
    ───────────────────────────────────────────── */
    function initIdentifyScreen() {
        var returnTo = encodeURIComponent(buildReturnUrl());

        var flow = WsIdentifyFlow.create({
            els: {
                identityRow: '#ws-checkout-init-identity-row',
                identityInput: '#ws-checkout-init-guest-identity',
                displayRow: '#ws-checkout-init-guest-identity-display',
                displayValue: '#ws-checkout-init-guest-identity-value',
                changeIdentityLink: '#ws-checkout-init-guest-change-identity',
                passwordField: '#ws-checkout-init-guest-password-field',
                passwordRow: '#ws-checkout-init-password-row',
                passwordInput: '#ws-checkout-init-guest-password',
                continueBtn: '#ws-checkout-init-guest-continue',
                continueLabel: '#ws-checkout-init-guest-continue-label',
                mainMsg: '#ws-checkout-init-guest-msg',
                title: '#ws-checkout-init-guest-title',
                subtitle: '#ws-checkout-init-guest-subtitle',
                googleBtn: '#ws-checkout-init-guest-google',
                facebookBtn: '#ws-checkout-init-guest-facebook',
            },
            moveButton: true,
            socialSignupFallback: true,

            onIdentityNew: function (identity) {
                _identity = identity;
                hide('ws-checkout-init-screen-guest');
                enterAccordionScreen((_initData && _initData.record) || {}, false);
            },
            onSocialSignupResolved: function (provider, data) {
                if (!data || !data.email) return;
                _identity = { type: 'email', value: data.email, name: data.name || '' };
                hide('ws-checkout-init-screen-guest');
                enterAccordionScreen((_initData && _initData.record) || {}, false);
            },
            onLoginSuccess: function () {
                hide('ws-checkout-init-screen-guest');
                init();
            },
            onCheckIdentityError: function () {
                window.location.href = '/login?return_to=' + returnTo;
            },
        });

        flow.init();
    }

    /* ─────────────────────────────────────────────
       RENDER: DETALHES DO PEDIDO (sidebar)
    ───────────────────────────────────────────── */
    function renderOrderDetails(cart, order) {
        var sidebarEl = el('ws-checkout-init-sidebar-totals');
        if (!sidebarEl) return;

        var products   = (cart && cart.products) || [];
        var shipping   = (cart && cart.shipping) || {};
        var totalProds = cart.subtotal || 0;
        // shipping.id só existe quando uma forma de envio já foi de fato
        // escolhida (mesmo campo usado como preSelectId em initAddressStep) —
        // sem ele, shipping.price vem undefined/0 e a conta abaixo lia isso
        // como "frete grátis" mesmo sem o cliente ter chegado a calcular.
        var shippingChosen = !!shipping.id;
        var totalShip  = shippingChosen ? (shipping.isFree ? 0 : (shipping.price || 0)) : 0;
        // cart.total é só o subtotal dos produtos (mesmo campo usado em
        // totalProds) — o total de fato (produtos + frete) vem de order.total,
        // o mesmo valor já usado em updatePaymentTotal/renderPaymentMethods.
        var total      = (order && order.total) || 0;
        var shipLabel  = !shippingChosen ? 'A calcular' : (totalShip === 0 ? 'Grátis' : fmtPrice(totalShip));

        sidebarEl.innerHTML =
            '<div class="wscb-totals-row"><span>Itens</span><span>' + products.length + '</span></div>' +
            '<div class="wscb-totals-row"><span>Subtotal</span><span>' + fmtPrice(totalProds) + '</span></div>' +
            (cart && cart.sendable === false ? '' : '<div class="wscb-totals-row"><span>Valor do frete</span><span>' + shipLabel + '</span></div>') +
            '<div class="wscb-totals-row wscb-totals-row--discount" id="ws-checkout-init-sidebar-discount-row" style="display:none">' +
                '<span>Desconto</span><span id="ws-checkout-init-sidebar-discount-value"></span>' +
            '</div>' +
            '<div class="wscb-totals-row wscb-totals-row--total"><span>Total</span><span id="ws-checkout-init-sidebar-total-value">' + fmtPrice(total) + '</span></div>';

        renderProductsList(products);
    }

    /* ─────────────────────────────────────────────
       BLOCO "PRODUTOS" (colapsável, fechado por padrão)
    ───────────────────────────────────────────── */
    function renderProductsList(products) {
        // O innerHTML vai no filho "-inner" (padding/flex), não no elemento
        // "-body" (esse é o .wscb-collapse, controla só a altura — ver
        // initProductsCard/WsCheckoutBase.expand/collapse).
        var body = el('ws-checkout-init-products-body-inner');
        if (!body) return;

        body.innerHTML = (products || []).map(function (prod) {
            var vars = (prod.add_info || []).map(function (i) {
                return escHtml(i.title) + ': ' + escHtml(i.value);
            }).join(' | ');

            return '<div class="wscb-product-item">' +
                '<img class="wscb-product-item__photo" src="' + escHtml(prod.photo || '') + '" alt="' + escHtml(prod.name || '') + '">' +
                '<div>' +
                    '<div class="wscb-product-item__name">' + escHtml(prod.name || '') + '</div>' +
                    (vars ? '<div class="wscb-product-item__vars">' + vars + '</div>' : '') +
                    '<div class="wscb-product-item__row">' +
                        '<span>Quantidade: ' + (prod.quantity || 1) + '</span>' +
                        '<span class="wscb-product-item__price">' + fmtPrice(prod.real_price) + '</span>' +
                    '</div>' +
                '</div>' +
            '</div>';
        }).join('');
    }

    function initProductsCard() {
        var card   = el('ws-checkout-init-products-card');
        var toggle = el('ws-checkout-init-products-toggle');
        var body   = el('ws-checkout-init-products-body');
        if (!card || !toggle || !body) return;

        toggle.addEventListener('click', function () {
            var expanded = card.classList.toggle('wscb-expanded');
            if (expanded) WsCheckoutBase.expand(body);
            else WsCheckoutBase.collapse(body);
        });
    }

    function refreshCheckout(data) {
        _initData = data;
        var record = (data && data.record) || {};
        var cart   = record.cart || {};
        var order  = record.order || {};
        var total  = order.total || 0;

        renderOrderDetails(cart, order);
        renderCoupon(cart.cupom);

        if (_selectedPayment) {
            updatePaymentTotal(total);
        }
    }

    /* ─────────────────────────────────────────────
       STEP 1 — INFORMAÇÕES PESSOAIS
       GET/POST /user/data/personal-info — mesmo contrato
       já usado por wsapi3-customer-area-page.js.
    ───────────────────────────────────────────── */
    function updatePersonalPreview() {
        var name  = (el('ws-checkout-init-p-name')  || {}).value || '';
        var cpf   = (el('ws-checkout-init-p-cpf')   || {}).value || '';
        var email = (el('ws-checkout-init-p-email') || {}).value || '';
        var parts = [name, cpf, email].filter(Boolean);
        var previewEl = el('ws-checkout-init-p-preview');
        if (previewEl) previewEl.textContent = parts.join('  |  ');
    }

    function maskPhone(v) {
        var d = String(v || '').replace(/\D/g, '').slice(0, 11);
        if (d.length > 10) return '(' + d.slice(0,2) + ') ' + d.slice(2,7) + '-' + d.slice(7);
        if (d.length > 6)  return '(' + d.slice(0,2) + ') ' + d.slice(2,6) + '-' + d.slice(6);
        if (d.length > 2)  return '(' + d.slice(0,2) + ') ' + d.slice(2);
        if (d.length > 0)  return '(' + d;
        return d;
    }

    // Celular válido: DDD (2 dígitos, não pode começar com 0) + 9 (nono
    // dígito, padrão nacional desde 2016) + 8 dígitos = 11 no total.
    function isValidMobile(v) {
        return /^[1-9]\d9\d{8}$/.test(onlyDigits(v));
    }

    /* Cliente já identificado/logado: sem campos, só texto — e já pula pra
       etapa de endereço (não há nada pra preencher aqui). Os dados vêm do
       próprio customer do /cart/checkout/init, sem chamada extra. */
    function renderPersonalInfoView(customer) {
        var c = customer || {};
        show('ws-checkout-init-p-view');
        hide('ws-checkout-init-p-form');
        hide('ws-checkout-init-p-edit-icon');

        setField('ws-checkout-init-r-name', c.name || '');

        function fillText(id, value) {
            var target = el(id);
            if (target) target.textContent = value || '—';
        }
        fillText('ws-checkout-init-pv-name', c.name);
        fillText('ws-checkout-init-pv-email', c.email);
        fillText('ws-checkout-init-pv-cpf', c.cpf_cnpj ? fmtCpf(c.cpf_cnpj) : '');
        fillText('ws-checkout-init-pv-mobile', c.phone_mobile || c.mobile || c.phone);

        var previewEl = el('ws-checkout-init-p-preview');
        if (previewEl) previewEl.textContent = [c.name, c.email].filter(Boolean).join('  |  ');

        advanceToStep('address');
    }

    /* Cliente novo (check-signup não encontrou o e-mail/CPF): formulário
       editável, pré-preenchido só com o que ele já digitou na identificação.
       A conta só é criada de fato no "Finalizar compra" (ver doSignupThenProceed). */
    function renderPersonalInfoEditable(identity) {
        show('ws-checkout-init-p-form');
        hide('ws-checkout-init-p-view');

        if (identity && identity.type === 'email') {
            setField('ws-checkout-init-p-email', identity.value);
        } else if (identity && identity.type === 'cpf_cnpj') {
            var cpfEl = el('ws-checkout-init-p-cpf');
            if (cpfEl) cpfEl.value = fmtCpf(identity.value);
        }
        // Só vem preenchido quando a identidade veio do login social sem
        // conta ainda (ver onSocialSignupResolved) — o Google devolve o
        // nome junto do e-mail, então já adianta esse campo também.
        if (identity && identity.name) setField('ws-checkout-init-p-name', identity.name);

        updatePersonTypeUI();
        updatePersonalPreview();
    }

    // PF/PJ é decidido só pelo próprio CPF/CNPJ digitado (sem seletor manual
    // de tipo de pessoa) — troca o label/placeholder de "Nome completo" pra
    // "Razão Social" e mostra o campo extra "Nome do responsável" (vai como
    // "contact" no /auth/signup, ver doSignupThenProceed). Mesma detecção de
    // modo CNPJ que fmtCpf já usa internamente (letra OU mais de 11 chars).
    function updatePersonTypeUI() {
        var raw = onlyCpfCnpjChars((el('ws-checkout-init-p-cpf') || {}).value || '');
        var isCnpj = /[A-Z]/.test(raw) || raw.length > 11;

        var nameLabel = el('ws-checkout-init-p-name-label');
        var nameInp = el('ws-checkout-init-p-name');
        var contactField = el('ws-checkout-init-p-contact-field');

        if (nameLabel) nameLabel.textContent = isCnpj ? 'Razão Social' : 'Nome completo';
        if (nameInp) nameInp.placeholder = isCnpj ? 'Razão social da empresa' : 'Seu nome completo';
        if (contactField) contactField.classList.toggle('wscb-hidden', !isCnpj);
    }

    function initPersonalInfoStep() {
        WsIdentifyFlow.bindPasswordToggle(el('ws-checkout-init-p-password'));

        // Assim que a pessoa mexe em qualquer campo, limpa o erro dele (borda
        // vermelha + mensagem abaixo) — não espera o próximo "Continuar".
        PERSONAL_FIELD_IDS.forEach(function (id) {
            var inp = el(id);
            if (!inp) return;
            var evt = (inp.tagName === 'SELECT') ? 'change' : 'input';
            inp.addEventListener(evt, function () { clearFieldError(id); });
        });

        var cpfInp = el('ws-checkout-init-p-cpf');
        if (cpfInp) cpfInp.addEventListener('input', function () {
            // Sem onlyDigits() aqui — precisa preservar letra pro fluxo de
            // CNPJ alfanumérico; fmtCpf já filtra/limita os caracteres certos.
            cpfInp.value = fmtCpf(cpfInp.value);
            updatePersonTypeUI();
        });
        updatePersonTypeUI();

        var mobileInp = el('ws-checkout-init-p-mobile');
        if (mobileInp) mobileInp.addEventListener('input', function () { mobileInp.value = maskPhone(mobileInp.value); });

        var birthInp = el('ws-checkout-init-p-birth');
        if (birthInp) birthInp.addEventListener('input', function () { birthInp.value = maskBirthday(birthInp.value); });
        wireBirthdayDatePicker('ws-checkout-init-p-birth-toggle', 'ws-checkout-init-p-birth-native', 'ws-checkout-init-p-birth');

        // E-mail/CPF já cadastrados (/user/access/check-signup) — checagem
        // "de verdade" (bloqueia avançar) vive no clique de saveBtn mais
        // abaixo; aqui é só o aviso adiantado no blur de cada campo, mesmo
        // padrão de wsapi3-signup-page.js (attachCheckBlur/applyCheckResult),
        // simplificado pro único bloco de mensagem que esta etapa já usa (sem
        // ícone/classe por campo). "email"/"cpf_cnpj" pra bater com as chaves
        // que a API devolve em record.
        var emailInp = el('ws-checkout-init-p-email');
        if (emailInp) {
            emailInp.addEventListener('blur', function () {
                var raw = emailInp.value.trim();
                if (!/\S+@\S+\.\S+/.test(raw)) return;
                ApiWS.Calls.checkSignup({ email: raw }).then(function (data) {
                    var result = data && data.record && data.record.email;
                    if (result && result.exists) {
                        setFieldError('ws-checkout-init-p-email', 'Este e-mail já está cadastrado. Faça login para continuar.');
                    }
                }).catch(function () { }); // falha de rede aqui não bloqueia — a checagem "de verdade" é refeita no Continuar
            });
        }
        if (cpfInp) {
            cpfInp.addEventListener('blur', function () {
                var value = onlyCpfCnpjChars(cpfInp.value);
                if (value.length !== 11 && value.length !== 14) return;
                if (!isValidCpfCnpj(value)) {
                    setFieldError('ws-checkout-init-p-cpf', 'CPF/CNPJ inválido.');
                    return;
                }
                ApiWS.Calls.checkSignup({ cpf_cnpj: value }).then(function (data) {
                    var result = data && data.record && data.record.cpf_cnpj;
                    if (result && result.exists) {
                        setFieldError('ws-checkout-init-p-cpf', 'Este CPF/CNPJ já está cadastrado. Faça login para continuar.');
                    }
                }).catch(function () { });
            });
        }

        // Cliente já identificado: reabrindo o step 1 (clicando no cabeçalho) pra
        // conferir os dados, o botão aqui só avança pro endereço — nada a salvar.
        var pContinueBtn = el('ws-checkout-init-p-continue');
        if (pContinueBtn) {
            pContinueBtn.addEventListener('click', function () {
                advanceToStep('address');
            });
        }

        var saveBtn = el('ws-checkout-init-p-save');
        if (!saveBtn) return;

        // Só existe cadastro pra "salvar" aqui no cenário de cliente novo — o
        // cliente já identificado nem vê este formulário (renderPersonalInfoView
        // esconde #ws-checkout-init-p-form). Nada é persistido agora — só valida
        // localmente e avança; a conta é criada de fato no Finalizar compra.
        saveBtn.addEventListener('click', function () {
            setMsg('ws-checkout-init-p-msg', '', '');
            clearAllPersonalFieldErrors();

            var name     = (el('ws-checkout-init-p-name') || {}).value || '';
            var email    = (el('ws-checkout-init-p-email') || {}).value || '';
            var cpf      = onlyCpfCnpjChars((el('ws-checkout-init-p-cpf') || {}).value || '');
            var isCnpj   = cpf.length === 14;
            var contact  = (el('ws-checkout-init-p-contact') || {}).value || '';
            var mobile   = (el('ws-checkout-init-p-mobile') || {}).value || '';
            var birth    = (el('ws-checkout-init-p-birth') || {}).value || '';
            var password = (el('ws-checkout-init-p-password') || {}).value || '';
            var gender   = (el('ws-checkout-init-p-gender') || {}).value || '';

            // Valida TODOS os campos de uma vez — cada erro marca o próprio
            // campo (borda vermelha + mensagem abaixo dele), não para no
            // primeiro. Só avança se nada estiver inválido.
            var firstInvalidId = null;
            function fail(id, message) {
                setFieldError(id, message);
                if (!firstInvalidId) firstInvalidId = id;
            }

            if (!name.trim()) fail('ws-checkout-init-p-name', isCnpj ? 'Informe a razão social.' : 'Informe seu nome completo.');
            if (!isValidCpfCnpj(cpf)) fail('ws-checkout-init-p-cpf', 'Informe um CPF/CNPJ válido.');
            if (isCnpj && !contact.trim()) fail('ws-checkout-init-p-contact', 'Informe o nome do responsável.');
            if (!/\S+@\S+\.\S+/.test(email)) fail('ws-checkout-init-p-email', 'Informe um e-mail válido.');
            if (!mobile) fail('ws-checkout-init-p-mobile', 'Informe seu telefone celular.');
            else if (!isValidMobile(mobile)) fail('ws-checkout-init-p-mobile', 'Informe um número de celular válido, com DDD.');
            if (!parseBirthdayToIso(birth)) fail('ws-checkout-init-p-birth', 'Informe uma data de nascimento válida.');
            // Senha é opcional — sem senha, o cadastro vai sem senha e a API
            // resolve (envia link pra definir depois). Só valida o mínimo se a
            // pessoa realmente digitou algo.
            if (password && password.length < 6) fail('ws-checkout-init-p-password', 'A senha deve ter pelo menos 6 caracteres.');
            if (!gender) fail('ws-checkout-init-p-gender', 'Selecione seu gênero.');

            if (firstInvalidId) {
                var firstEl = el(firstInvalidId);
                if (firstEl) {
                    firstEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    try { firstEl.focus({ preventScroll: true }); } catch (e) { firstEl.focus(); }
                }
                return;
            }

            // Reconfirma e-mail/CPF-CNPJ na hora de avançar (não só no blur —
            // cobre colar/autofill sem passar pelo blur, e o valor pode ter
            // mudado depois da última checagem). Uma chamada só com os dois
            // campos: a API devolve email/cpf_cnpj como null quando não
            // consultado, então nunca sobra ambíguo qual resultado é qual.
            saveBtn.disabled = true;
            var originalLabel = saveBtn.textContent;
            saveBtn.textContent = 'Verificando...';

            ApiWS.Calls.checkSignup({ email: email, cpf_cnpj: cpf }).then(function (data) {
                saveBtn.disabled = false;
                saveBtn.textContent = originalLabel;

                var record   = (data && data.record) || {};
                var emailRes = record.email;
                var cpfRes   = record.cpf_cnpj;

                if (emailRes && emailRes.exists) {
                    setFieldError('ws-checkout-init-p-email', 'Este e-mail já está cadastrado. Faça login para continuar.');
                }
                if (cpfRes && cpfRes.exists) {
                    setFieldError('ws-checkout-init-p-cpf', 'Este CPF/CNPJ já está cadastrado. Faça login para continuar.');
                }
                if ((emailRes && emailRes.exists) || (cpfRes && cpfRes.exists)) {
                    var dupEl = el((emailRes && emailRes.exists) ? 'ws-checkout-init-p-email' : 'ws-checkout-init-p-cpf');
                    if (dupEl) dupEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    return;
                }

                setField('ws-checkout-init-r-name', name);
                updatePersonalPreview();
                advanceToStep('address');
            }).catch(function () {
                saveBtn.disabled = false;
                saveBtn.textContent = originalLabel;
                setMsg('ws-checkout-init-p-msg', 'Erro de conexão ao verificar seus dados. Tente novamente.', 'error');
            });
        });
    }

    /* ─────────────────────────────────────────────
       CRIA A CONTA (auth/signup) ANTES DE FINALIZAR
       Só roda quando _needsSignup é true (identificação não encontrou o
       e-mail/CPF). Usa os dados do bloco 1 (pessoais) + bloco 2 (endereço,
       já que /auth/signup exige um endereço de cadastro) — mesmo contrato
       de wsapi3-signup-page.js.
    ───────────────────────────────────────────── */
    function doSignupThenProceed(resetBtn, onSuccess) {
        // Senha é opcional aqui — se veio vazia, o cadastro segue sem senha e a
        // API resolve. Só barra se a pessoa digitou algo curto demais (mesma
        // regra da validação do botão "Continuar" em initPersonalInfoStep).
        var password = (el('ws-checkout-init-p-password') || {}).value || '';
        if (password && password.length < 6) {
            resetBtn();
            wsMain.showAlert('A senha deve ter pelo menos 6 caracteres, ou deixe o campo em branco, na etapa "Informações pessoais".', 'Atenção');
            WsCheckoutBase.openStep(accordionContainer(), 'personal');
            return;
        }

        // birth_date é exigido pelo /auth/signup ("Data de nascimento é
        // obrigatória para pessoa física") — mesma checagem defensiva de
        // password acima, pro caso de chegar aqui sem passar pela validação
        // do botão "Continuar" da etapa (ver saveBtn em initPersonalInfoStep).
        var birthIso = parseBirthdayToIso((el('ws-checkout-init-p-birth') || {}).value || '');
        if (!birthIso) {
            resetBtn();
            wsMain.showAlert('Informe uma data de nascimento válida na etapa "Informações pessoais".', 'Atenção');
            WsCheckoutBase.openStep(accordionContainer(), 'personal');
            return;
        }

        // "cpfDigits" pode ter letras agora (CNPJ alfanumérico) — nome mantido
        // só pra não mexer em mais linhas do que precisa.
        var cpfDigits = onlyCpfCnpjChars((el('ws-checkout-init-p-cpf') || {}).value || '');

        var signupBody = {
            name:           (el('ws-checkout-init-p-name') || {}).value || '',
            email:          (el('ws-checkout-init-p-email') || {}).value || '',
            password:       password,
            person_type:    cpfDigits.length === 14 ? 'J' : 'F',
            birth_date:     birthIso,
            cpf_cnpj:       cpfDigits,
            mobile:         onlyDigits((el('ws-checkout-init-p-mobile') || {}).value || ''),
            zip_code:       cleanCep((el('ws-checkout-init-cep') || {}).value || ''),
            address:        (el('ws-checkout-init-r-address')      || {}).value || '',
            address_number: (el('ws-checkout-init-r-number')       || {}).value || '',
            neighborhood:   (el('ws-checkout-init-r-neighborhood') || {}).value || '',
            city:           (el('ws-checkout-init-r-city')         || {}).value || '',
            state:          (el('ws-checkout-init-r-state')        || {}).value || '',
            newsletter:     !!(el('ws-checkout-init-p-newsletter') || {}).checked
        };
        // "none" ("Prefiro não informar") é só um valor de controle da UI pra
        // diferenciar de "nada selecionado" (ver o <select> no HTML) — não há
        // confirmação de que o /auth/signup aceite um gender pra "prefiro não
        // informar", então aqui ele vira o mesmo "não manda o campo" de antes.
        var genderVal = (el('ws-checkout-init-p-gender') || {}).value || '';
        if (genderVal && genderVal !== 'none') signupBody.gender = genderVal;
        var complementVal = (el('ws-checkout-init-r-complement') || {}).value || '';
        if (complementVal) signupBody.complement = complementVal;
        // Pessoa jurídica: "Nome do responsável" vai como "contact" (mesma
        // convenção de wsapi3-signup-page.js), name acima já carrega a razão
        // social nesse caso.
        if (cpfDigits.length === 14) {
            var contactVal = (el('ws-checkout-init-p-contact') || {}).value || '';
            if (contactVal.trim()) signupBody.contact = contactVal;
        }

        ApiWS.Calls.signup(signupBody).then(function (data) {
            if (data && data.result === 'success' && data.record) {
                ApiWS.User.saveSession(data.record);
                _needsSignup = false;
                onSuccess();
            } else {
                resetBtn();
                wsMain.showAlert((data && data.message) || 'Não foi possível concluir seu cadastro. Verifique os dados e tente novamente.', 'Atenção');
                WsCheckoutBase.openStep(accordionContainer(), 'personal');
            }
        }).catch(function () {
            resetBtn();
            wsMain.showAlert('Erro de conexão ao criar seu cadastro. Tente novamente.', 'Atenção');
        });
    }

    /* ─────────────────────────────────────────────
       STEP 2 — ENDEREÇO DE ENTREGA
    ───────────────────────────────────────────── */
    function updateAddressPreview() {
        var cep    = (el('ws-checkout-init-cep')         || {}).value || '';
        var addr   = (el('ws-checkout-init-r-address')   || {}).value || '';
        var number = (el('ws-checkout-init-r-number')    || {}).value || '';
        var parts = [];
        if (cep) parts.push(cep);
        if (addr) parts.push(addr + (number ? ', ' + number : ''));
        var previewEl = el('ws-checkout-init-r-preview');
        if (previewEl) previewEl.textContent = parts.join('  |  ');
    }

    function fillAddressFromViaCep(v) {
        setField('ws-checkout-init-r-address',      v.logradouro || '');
        setField('ws-checkout-init-r-neighborhood', v.bairro || '');
        setField('ws-checkout-init-r-city',         v.localidade || '');
        setField('ws-checkout-init-r-state',        v.uf || '');
    }

    /* ─────────────────────────────────────────────
       LISTA DE ENDEREÇOS SALVOS (cliente já com cadastro)
       GET/POST /user/data/personal-info — mesmo contrato de endereços já
       usado em wsapi3-customer-area-page.js (campo "addresses").
    ───────────────────────────────────────────── */
    function showAddressList() {
        openCollapse('ws-checkout-init-addr-list');
        closeCollapse('ws-checkout-init-addr-form');
    }

    function showAddressForm() {
        closeCollapse('ws-checkout-init-addr-list');
        openCollapse('ws-checkout-init-addr-form');
        var backLink = el('ws-checkout-init-addr-back-to-list');
        if (backLink) backLink.style.display = _addresses.length ? '' : 'none';
    }

    function addressSummaryLines(addr) {
        var line1 = (addr.address || '') + (addr.number ? ', ' + addr.number : '');
        var cityState = [addr.city, addr.state].filter(Boolean).join('/');
        var line2Parts = [];
        if (addr.neighborhood) line2Parts.push(addr.neighborhood);
        if (cityState) line2Parts.push(cityState);
        if (addr.zipcode) line2Parts.push('CEP ' + fmtCep(addr.zipcode));
        return escHtml(line1) + '<br>' + escHtml(line2Parts.join(' - '));
    }

    function fillFormFromAddress(addr, custName) {
        var cepEl = el('ws-checkout-init-cep');
        if (cepEl) cepEl.value = fmtCep(addr.zipcode || '');
        setField('ws-checkout-init-r-name',         addr.recipient || custName || '');
        setField('ws-checkout-init-r-address',      addr.address || '');
        setField('ws-checkout-init-r-number',       addr.number || '');
        setField('ws-checkout-init-r-complement',   addr.complement || '');
        setField('ws-checkout-init-r-neighborhood', addr.neighborhood || '');
        setField('ws-checkout-init-r-city',         addr.city || '');
        setField('ws-checkout-init-r-state',        addr.state || '');
        var countryEl = el('ws-checkout-init-r-country');
        if (countryEl) countryEl.value = 'Brasil';
        var refEl = el('ws-checkout-init-r-reference');
        if (refEl) refEl.value = '';
    }

    function selectAddressCard(idx, custName) {
        _selectedAddressIdx = idx;
        document.querySelectorAll('#ws-checkout-init-addr-cards .wscb-option').forEach(function (card, i) {
            card.classList.toggle('wscb-option--selected', i === idx);
            var radio = card.querySelector('input[type="radio"]');
            if (radio) radio.checked = (i === idx);
        });

        var addr = _addresses[idx];
        if (!addr) return;

        fillFormFromAddress(addr, custName);
        updateAddressPreview();

        _selectedShipping = null;
        var zip = cleanCep(addr.zipcode || '');
        if (zip.length === 8) calculateShipping(zip, null);
    }

    function renderAddressCards(custName) {
        var container = el('ws-checkout-init-addr-cards');
        if (!container) return;

        container.innerHTML = _addresses.map(function (addr, i) {
            var id = 'ws-checkout-init-addr-' + i;
            return '<label class="wscb-option" for="' + id + '">' +
                '<input type="radio" name="ws-checkout-init-addr" id="' + id + '" value="' + i + '">' +
                '<span>' +
                '<span class="wscb-option__title">' + escHtml(addr.label || 'Endereço') + '</span>' +
                '<span class="ws-checkout-init-address-option__lines">' + addressSummaryLines(addr) + '</span>' +
                '</span>' +
                '</label>';
        }).join('');

        container.querySelectorAll('input[type="radio"]').forEach(function (radio, i) {
            radio.addEventListener('change', function () { selectAddressCard(i, custName); });
        });
    }

    function initAddressListStep() {
        var addTrigger = el('ws-checkout-init-addr-add-trigger');
        if (addTrigger) {
            addTrigger.addEventListener('click', function (e) {
                e.preventDefault();
                showAddressForm();
            });
        }

        var backLink = el('ws-checkout-init-addr-back-to-list');
        if (backLink) {
            backLink.addEventListener('click', function (e) {
                e.preventDefault();
                showAddressList();
            });
        }

        var continueBtn = el('ws-checkout-init-addr-continue');
        if (continueBtn) {
            continueBtn.addEventListener('click', function () {
                if (_selectedAddressIdx < 0) {
                    setMsg('ws-checkout-init-addr-list-msg', 'Selecione um endereço.', 'error');
                    return;
                }
                var shipOptsEl = el('ws-checkout-init-shipping-options');
                if (!shipOptsEl || !shipOptsEl.children.length) {
                    setMsg('ws-checkout-init-addr-list-msg', 'Aguarde o cálculo do frete para este endereço.', 'error');
                    return;
                }
                setMsg('ws-checkout-init-addr-list-msg', '', '');
                setMsg('ws-checkout-init-shipping-msg', '', '');
                advanceToStep('shipping');
            });
        }
    }

    /* Carrega a lista de endereços do cliente (cartCheckoutInit não traz essa
       lista, só um endereço avulso) e decide a etapa 2: lista (se houver
       endereços salvos) ou formulário direto (se ainda não tiver nenhum). */
    function loadAddressList(cart, customer) {
        var shipping = (cart && cart.shipping) || {};
        var cartZip  = normZip(shipping.zip_code || '');
        var custName = (customer && customer.name) || '';

        ApiWS.Calls._get('/user/data/personal-info/view').then(function (data) {
            _addresses = (data && data.result === 'success' && data.record && data.record.addresses) || [];

            if (!_addresses.length) {
                showAddressForm();
                tryPreFillAddress(cart, customer);
                return;
            }

            renderAddressCards(custName);
            showAddressList();

            // Pré-seleciona: o endereço cujo CEP bate com o do carrinho, senão o
            // principal, senão o primeiro da lista.
            var matchIdx = -1;
            for (var i = 0; i < _addresses.length; i++) {
                if (cartZip && normZip(_addresses[i].zipcode || '') === cartZip) { matchIdx = i; break; }
            }
            var defaultIdx = matchIdx;
            if (defaultIdx < 0) {
                for (var j = 0; j < _addresses.length; j++) {
                    if (_addresses[j].main) { defaultIdx = j; break; }
                }
            }
            if (defaultIdx < 0) defaultIdx = 0;

            selectAddressCard(defaultIdx, custName);
        }).catch(function () {
            showAddressForm();
            tryPreFillAddress(cart, customer);
        });
    }

    function tryPreFillAddress(cart, customer) {
        var shipping    = (cart && cart.shipping) || {};
        var cartZip     = normZip(shipping.zip_code || '');
        var preSelectId = String(shipping.id || '');
        var custAddr    = (customer && customer.address) || {};
        var custName    = (customer && customer.name) || '';

        // Destinatário: usa o do frete (pode ser diferente do comprador) ou nome do cliente
        // (também é atualizado quando a etapa "Informações pessoais" é salva)
        setField('ws-checkout-init-r-name', shipping.recipient || custName);

        if (!cartZip) { updateAddressPreview(); return; }

        var cepEl = el('ws-checkout-init-cep');
        if (cepEl) cepEl.value = fmtCep(cartZip);

        // Prioridade 1: campos de endereço já resolvidos no shipping pela API
        if (shipping.street) {
            setField('ws-checkout-init-r-address',      shipping.street);
            setField('ws-checkout-init-r-number',       shipping.number || '');
            setField('ws-checkout-init-r-complement',   shipping.complement || '');
            setField('ws-checkout-init-r-reference',    shipping.reference || '');
            setField('ws-checkout-init-r-neighborhood', shipping.neighborhood || '');
            setField('ws-checkout-init-r-city',         shipping.city || '');
            setField('ws-checkout-init-r-state',        shipping.state || '');
            setField('ws-checkout-init-r-country',      'Brasil');
        } else {
            // Fallback: endereço cadastrado do cliente se o CEP bater
            var custZip = normZip(custAddr.zip_code || '');
            if (custZip && custZip === cartZip) {
                setField('ws-checkout-init-r-address',      custAddr.street || '');
                setField('ws-checkout-init-r-number',       custAddr.number || '');
                setField('ws-checkout-init-r-complement',   custAddr.complement || '');
                setField('ws-checkout-init-r-reference',    custAddr.reference || '');
                setField('ws-checkout-init-r-neighborhood', custAddr.neighborhood || '');
                setField('ws-checkout-init-r-city',         custAddr.city || '');
                setField('ws-checkout-init-r-state',        custAddr.state || '');
                setField('ws-checkout-init-r-country',      custAddr.country || 'Brasil');
            }
        }

        updateAddressPreview();
        calculateShipping(cartZip, preSelectId);
    }

    /* Trava o botão "Continuar para forma de envio" enquanto o frete ainda está sendo
       calculado — antes, o botão ficava clicável normalmente nessa janela, e um clique
       nela só mostrava um erro ("Aguarde o cálculo do frete...") depois do fato. Trocando
       por um estado desabilitado + texto de espera: nem dá pra clicar antes de estar pronto,
       nem precisa do usuário descobrir isso via mensagem de erro. */
    function lockShippingContinueButton() {
        var continueBtn = el('ws-checkout-init-addr-continue');
        if (!continueBtn) return;
        if (!continueBtn.dataset.originalText) continueBtn.dataset.originalText = continueBtn.textContent;
        continueBtn.disabled = true;
        continueBtn.textContent = 'Calculando frete, aguarde...';
    }

    function unlockShippingContinueButton() {
        var continueBtn = el('ws-checkout-init-addr-continue');
        if (!continueBtn) return;
        continueBtn.disabled = false;
        if (continueBtn.dataset.originalText) continueBtn.textContent = continueBtn.dataset.originalText;
    }

    /* ─────────────────────────────────────────────
       CÁLCULO DE FRETE (função central)
    ───────────────────────────────────────────── */
    async function calculateShipping(cep, preSelectId) {
        var calcBtn = el('ws-checkout-init-calc-cep');
        if (calcBtn) { calcBtn.disabled = true; calcBtn.textContent = 'Buscando...'; }
        setMsg('ws-checkout-init-cep-msg', '', '');
        lockShippingContinueButton();

        try {
            var data = await ApiWS.Calls._get('/cart/shipping/calculate', { zipcode: cep, cart_token: _ct });

            if (calcBtn) { calcBtn.disabled = false; calcBtn.textContent = 'BUSCAR'; }

            var options = (data && data.record && data.record.shipping_options) ||
                          (data && data.records) ||
                          (data && data.shipping_options) || [];

            if (!options.length) {
                setMsg('ws-checkout-init-cep-msg', 'Frete indisponível para esta região.', 'error');
                return;
            }

            var addrField = el('ws-checkout-init-r-address');
            if (addrField && !addrField.value) {
                var v = await fetchViaCep(cep);
                if (v && !v.erro) fillAddressFromViaCep(v);
            }

            renderShippingOptions(options, preSelectId);
            updateAddressPreview();
        } catch (e) {
            if (calcBtn) { calcBtn.disabled = false; calcBtn.textContent = 'BUSCAR'; }
            setMsg('ws-checkout-init-cep-msg', 'Erro ao calcular frete. Tente novamente.', 'error');
        } finally {
            unlockShippingContinueButton();
        }
    }

    function initCepCalculator() {
        var calcBtn = el('ws-checkout-init-calc-cep');
        var cepInp  = el('ws-checkout-init-cep');
        if (!calcBtn || !cepInp) return;

        // Dispara sozinho (sem esperar o clique em "Buscar") assim que o CEP
        // fica completo (8 dígitos) ou o campo perde o foco — só quando o
        // endereço ainda está vazio, pra não sobrescrever um endereço que o
        // cliente já preencheu (ou que veio de um endereço salvo).
        function maybeAutoSearch() {
            var cep = cleanCep(cepInp.value);
            var addressEl = el('ws-checkout-init-r-address');
            var addressFilled = addressEl && addressEl.value.trim();
            if (cep.length === 8 && !addressFilled) calcBtn.click();
        }

        cepInp.addEventListener('input', function () {
            this.value = fmtCep(this.value);
            maybeAutoSearch();
        });

        cepInp.addEventListener('blur', maybeAutoSearch);

        calcBtn.addEventListener('click', function () {
            var cep = cleanCep(cepInp.value);
            if (cep.length < 8) {
                setMsg('ws-checkout-init-cep-msg', 'Informe um CEP válido.', 'error');
                return;
            }
            _selectedShipping = null;
            calculateShipping(cep, null);
        });

        cepInp.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') { e.preventDefault(); calcBtn.click(); }
        });
    }

    function initAddressStep() {
        var saveBtn = el('ws-checkout-init-r-save');
        if (!saveBtn) return;

        saveBtn.addEventListener('click', function () {
            var address = (el('ws-checkout-init-r-address') || {}).value || '';
            if (!address.trim()) {
                setMsg('ws-checkout-init-cep-msg', 'Informe o endereço de entrega.', 'error');
                return;
            }
            var shipOptsEl = el('ws-checkout-init-shipping-options');
            if (!shipOptsEl || !shipOptsEl.children.length) {
                setMsg('ws-checkout-init-cep-msg', 'Informe o CEP e clique em Buscar para calcular o frete.', 'error');
                return;
            }
            updateAddressPreview();

            // Cliente sem conta ainda: nada pra persistir agora — o endereço
            // vai junto no /auth/signup, disparado só no Finalizar compra.
            if (_needsSignup) {
                setMsg('ws-checkout-init-shipping-msg', '', '');
                advanceToStep('shipping');
                return;
            }

            // Cliente com conta: adiciona este endereço à lista salva (mesmo
            // contrato de wsapi3-customer-area-page.js — POST personal-info/save
            // com o array "addresses" completo).
            var newAddress = {
                id:           0,
                main:         _addresses.length === 0,
                label:        (el('ws-checkout-init-addr-label') || {}).value || 'Endereço',
                recipient:    (el('ws-checkout-init-r-name')         || {}).value || '',
                zipcode:      cleanCep((el('ws-checkout-init-cep')  || {}).value || ''),
                address:      address,
                number:       (el('ws-checkout-init-r-number')       || {}).value || '',
                complement:   (el('ws-checkout-init-r-complement')   || {}).value || '',
                neighborhood: (el('ws-checkout-init-r-neighborhood') || {}).value || '',
                city:         (el('ws-checkout-init-r-city')         || {}).value || '',
                state:        (el('ws-checkout-init-r-state')        || {}).value || ''
            };
            var updatedAddresses = _addresses.concat([newAddress]);

            saveBtn.disabled = true;
            var originalLabel = saveBtn.textContent;
            saveBtn.textContent = 'Aguarde...';

            ApiWS.Calls._post('/user/data/personal-info/save', { addresses: updatedAddresses })
                .then(function (data) {
                    saveBtn.disabled = false;
                    saveBtn.textContent = originalLabel;

                    if (!data || data.result !== 'success') {
                        setMsg('ws-checkout-init-cep-msg', (data && data.message) || 'Erro ao salvar endereço.', 'error');
                        return;
                    }

                    _addresses = updatedAddresses;
                    _selectedAddressIdx = updatedAddresses.length - 1;
                    setMsg('ws-checkout-init-shipping-msg', '', '');
                    advanceToStep('shipping');
                })
                .catch(function () {
                    saveBtn.disabled = false;
                    saveBtn.textContent = originalLabel;
                    setMsg('ws-checkout-init-cep-msg', 'Erro de conexão. Tente novamente.', 'error');
                });
        });
    }

    /* ─────────────────────────────────────────────
       STEP 3 — FORMAS DE ENVIO
    ───────────────────────────────────────────── */
    function updateShippingPreview(opt) {
        var previewEl = el('ws-checkout-init-shipping-preview');
        if (previewEl && opt) previewEl.textContent = opt.name || '';
    }

    function renderShippingOptions(options, preSelectId) {
        var container = el('ws-checkout-init-shipping-options');
        if (!container) return;

        container.innerHTML = '';

        // Reseta sempre aqui (não só nos pontos que chamam calculateShipping)
        // — sem isso, uma seleção de um cálculo de frete anterior (outro CEP,
        // por exemplo) podia sobreviver sem nenhum rádio marcado nesta nova
        // lista, deixando "Continuar" avançar com uma forma de envio que nem
        // aparece mais na tela.
        _selectedShipping = null;

        (options || []).forEach(function (opt, i) {
            var id         = 'ws-checkout-init-ship-' + i;
            var priceLabel = (parseFloat(opt.price) === 0 || opt.is_free) ? 'GRÁTIS' : fmtPrice(opt.price);
            var deadline   = opt.deadline ? fmtBusinessDays(opt.deadline) + ' – ' : '';

            var wrap = document.createElement('label');
            wrap.className = 'wscb-option ws-checkout-init-shipping-option';
            wrap.htmlFor = id;

            wrap.innerHTML =
                '<input type="radio" name="ws-checkout-init-shipping" id="' + id + '" value="' + i + '">' +
                '<span class="wscb-option__title">' + escHtml(titleCaseIfAllCaps(opt.name || '')) + '</span>' +
                '<span class="ws-checkout-init-shipping-option__info">' + deadline + priceLabel + '</span>';

            var radio = wrap.querySelector('input');

            radio.addEventListener('change', function () {
                document.querySelectorAll('#ws-checkout-init-shipping-options .wscb-option').forEach(function (e) {
                    e.classList.remove('wscb-option--selected');
                });
                wrap.classList.add('wscb-option--selected');
                _selectedShipping = opt;
                onShippingSelected(opt);
            });

            container.appendChild(wrap);

            var optId = String(opt.id || opt.shipping_id || '');
            if (preSelectId && optId && optId === String(preSelectId)) {
                radio.checked = true;
                wrap.classList.add('wscb-option--selected');
                _selectedShipping = opt;
            }
        });

        // Sem preSelectId batendo com nenhuma opção (cliente ainda não
        // escolheu/calculou frete), NÃO seleciona a primeira opção sozinho —
        // só marca de verdade quando o shipping do carrinho já constar esse
        // método (preSelectId, ver initAddressStep). Sem seleção real, o
        // botão "Continuar" (initShippingStep) já bloqueia o avanço.
        updateShippingPreview(_selectedShipping);
    }

    /* ─────────────────────────────────────────────
       SELEÇÃO DE FRETE → close → reload → avança p/ Pagamento
    ───────────────────────────────────────────── */
    function onShippingSelected(opt) {
        var cep = cleanCep((el('ws-checkout-init-cep') || {}).value || '');

        showOverlay();

        ApiWS.Calls.cartCheckoutShippingSelect({
            cartToken:        _ct,
            shippingId:       String(opt.id || opt.shipping_id || ''),
            shippingName:     opt.name || '',
            shippingPrice:    Number(opt.price || 0),
            shippingDiscount: Number(opt.discount || 0),
            shippingDeadline: Number(opt.deadline || 0),
            zipcode:          cep,
            scheduling:       opt.scheduling || ''
        })
        .then(function () {
            return ApiWS.Calls.cartCheckoutClose(_ct);
        })
        .then(function () {
            return ApiWS.Calls.cartCheckoutInit(_ct, _ct2, _orderNumber);
        })
        .then(function (data) {
            hideOverlay();
            refreshCheckout(data);
            updateShippingPreview(opt);
            // Não avança sozinho — o cliente confirma no botão "Continuar"
            // da própria etapa (ver initShippingStep), igual às demais etapas.
        })
        .catch(function (err) {
            hideOverlay();
            console.error('[ws-checkout-payment-page] shipping update error', err);
        });
    }

    function initShippingStep() {
        var continueBtn = el('ws-checkout-init-shipping-continue');
        if (!continueBtn) return;

        continueBtn.addEventListener('click', function () {
            if (!_selectedShipping) {
                setMsg('ws-checkout-init-shipping-msg', 'Selecione uma forma de envio.', 'error');
                return;
            }
            setMsg('ws-checkout-init-shipping-msg', '', '');
            advanceToStep('payment');
        });
    }

    /* ─────────────────────────────────────────────
       STEP 4 — PAGAMENTO
    ───────────────────────────────────────────── */
    function updatePaymentPreview(label) {
        var previewEl = el('ws-checkout-init-payment-preview');
        if (previewEl) previewEl.textContent = label || '';
    }

    function renderPaymentMethods(paymentMethods, orderTotal) {
        var container = el('ws-checkout-init-payment-methods');
        if (!container) return;

        container.innerHTML = '';

        var allOptions = [];
        (paymentMethods || []).forEach(function (pm) {
            (pm.options || []).forEach(function (opt) {
                allOptions.push({ gateway: pm, option: opt });
            });
        });

        allOptions.forEach(function (item, i) {
            var opt = item.option;
            var pm  = item.gateway;
            var id  = 'ws-checkout-init-pay-' + i;

            // No cartão, discount_percent é só o desconto de pagamento em 1x
            // (== discount_1x_percent) — não vale pra qualquer parcela, então
            // o selo não pode anunciar "X% de desconto" como se fosse geral.
            var discountLabel = '';
            if (opt.sub_type === 'credit_card') {
                var pct1x = opt.discount_1x_percent || opt.discount_percent;
                if (pct1x > 0) discountLabel = 'até ' + pct1x + '% em 1x';
            } else if (opt.discount_percent) {
                discountLabel = opt.discount_percent + '% de desconto';
            }

            var label = document.createElement('label');
            label.className = 'wscb-option ws-checkout-init-payment-method';
            label.htmlFor = id;

            label.innerHTML =
                '<input type="radio" name="ws-checkout-init-payment" id="' + id + '" value="' + i + '">' +
                '<span class="ws-checkout-init-payment-method__icon">' + getPaymentIcon(opt, pm) + '</span>' +
                '<span class="wscb-option__title">' + escHtml(opt.label || opt.sub_type || '') + '</span>' +
                (discountLabel ? '<span class="ws-checkout-init-payment-method__discount">' + discountLabel + '</span>' : '');

            label.querySelector('input').addEventListener('change', function () {
                document.querySelectorAll('#ws-checkout-init-payment-methods .wscb-option').forEach(function (e) {
                    e.classList.remove('wscb-option--selected');
                });
                label.classList.add('wscb-option--selected');
                _selectedPayment = { gateway: pm, option: opt };
                updatePaymentTotal(orderTotal);
                renderCardFields(opt);
                updatePaymentPreview(opt.label || opt.sub_type || '');
                show('ws-checkout-init-payment-edit-icon');
                WsCheckoutBase.expand(el('ws-checkout-init-finish-group'));
            });

            container.appendChild(label);
        });
    }

    /* Desconto da forma de pagamento (se houver) aparece direto no Resumo,
       como uma linha "Desconto" abaixo do frete, atualizando o Total ali
       mesmo — não existe mais um bloco de total separado na sidebar. */
    /* Parcela escolhida no select (installments[] da opção de cartão), ou
       null se nenhuma foi escolhida ainda. */
    function getSelectedInstallment(opt) {
        var qty = Number((el('ws-checkout-init-card-installments') || {}).value || 0);
        if (!qty) return null;
        return (opt.installments || []).filter(function (i) {
            return Number(i.quantity) === qty;
        })[0] || null;
    }

    /* No cartão o total vem do total_value da parcela escolhida (já inclui
       o desconto de 1x ou os juros) — total_with_discount do cartão é só o
       total da parcela 1 e não vale pras demais. Sem parcela escolhida, o
       Resumo mostra o total cheio do pedido. */
    function updatePaymentTotal(orderTotal) {
        if (!_selectedPayment) return;
        var opt = _selectedPayment.option;
        var hasDiscount, total, pct;
        if (opt.sub_type === 'credit_card') {
            var inst = getSelectedInstallment(opt);
            total       = (inst && inst.total_value > 0) ? inst.total_value : (orderTotal || 0);
            hasDiscount = total < (orderTotal || 0);
            pct         = (inst && Number(inst.quantity) === 1) ? (opt.discount_1x_percent || opt.discount_percent) : 0;
        } else {
            hasDiscount = (opt.discount_percent > 0) || (opt.discount_value > 0);
            total       = (opt.total_with_discount > 0) ? opt.total_with_discount : orderTotal || 0;
            pct         = opt.discount_percent;
        }

        var discountRow = el('ws-checkout-init-sidebar-discount-row');
        var discountVal = el('ws-checkout-init-sidebar-discount-value');
        if (discountRow) {
            if (hasDiscount) {
                var saved = Math.max((orderTotal || 0) - total, 0);
                var text  = '- ' + fmtPrice(saved);
                if (pct) text += ' (' + pct + '%)';
                if (discountVal) discountVal.textContent = text;
                discountRow.style.display = '';
            } else {
                discountRow.style.display = 'none';
            }
        }

        var totalVal = el('ws-checkout-init-sidebar-total-value');
        if (totalVal) totalVal.textContent = fmtPrice(total);
    }

    /* ─────────────────────────────────────────────
       MÁSCARAS DOS CAMPOS DE CARTÃO
    ───────────────────────────────────────────── */
    function maskCvc(v) {
        return v.replace(/\D/g, '').slice(0, 4);
    }
    function maskExpiry(v) {
        var d = v.replace(/\D/g, '').slice(0, 4);
        return d.length > 2 ? d.slice(0, 2) + '/' + d.slice(2) : d;
    }
    function maskBirthday(v) {
        var d = v.replace(/\D/g, '').slice(0, 8);
        if (d.length > 4) return d.slice(0, 2) + '/' + d.slice(2, 4) + '/' + d.slice(4);
        if (d.length > 2) return d.slice(0, 2) + '/' + d.slice(2);
        return d;
    }
    function maskCpf(v) {
        var d = v.replace(/\D/g, '').slice(0, 11);
        if (d.length > 9) return d.slice(0, 3) + '.' + d.slice(3, 6) + '.' + d.slice(6, 9) + '-' + d.slice(9);
        if (d.length > 6) return d.slice(0, 3) + '.' + d.slice(3, 6) + '.' + d.slice(6);
        if (d.length > 3) return d.slice(0, 3) + '.' + d.slice(3);
        return d;
    }
    function maskCardNumber(v) {
        return v.replace(/\D/g, '').slice(0, 16).replace(/(\d{4})(?=\d)/g, '$1 ');
    }

    function getMask(dataType) {
        var map = {
            cvc:         maskCvc,
            expiry:      maskExpiry,
            birthday:    maskBirthday,
            cpf:         maskCpf,
            card_number: maskCardNumber
        };
        return map[dataType] || null;
    }

    function attachCardFieldEvents(input, maskFn, regex) {
        var re = null;
        try { if (regex) re = new RegExp(regex); } catch (e) {}

        function validate() {
            if (!re) return;
            if (!input.value) {
                input.classList.remove('wscb-invalid');
                return;
            }
            if (re.test(input.value)) {
                input.classList.remove('wscb-invalid');
            } else {
                input.classList.add('wscb-invalid');
            }
        }

        input.addEventListener('input', function () {
            if (maskFn) input.value = maskFn(input.value);
            validate();
        });
        input.addEventListener('blur', validate);

        // Segurança: bloqueia colar (Ctrl+V, menu de contexto ou paste
        // programático) nos campos de dados do cartão — número, validade,
        // CVC, nome impresso, nascimento etc. Cobre qualquer forma de
        // disparo porque intercepta o próprio evento 'paste', não a tecla.
        input.addEventListener('paste', function (e) { e.preventDefault(); });
    }

    // "DD/MM/AAAA" (formato do campo texto/máscara) -> "AAAA-MM-DD" (formato aceito por
    // input[type=date]). Retorna '' se não bater com o formato completo (usuário ainda
    // digitando, ou vazio) — nesse caso o picker abre sem data pré-selecionada.
    function parseBirthdayToIso(value) {
        var m = String(value || '').trim().match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
        if (!m) return '';
        return m[3] + '-' + m[2] + '-' + m[1];
    }

    // Liga o ícone de calendário (ver renderCardFields e o campo "Data de
    // nascimento" das Informações pessoais) ao date picker nativo: clique
    // abre showPicker() num <input type="date"> escondido/sincronizado, a
    // escolha ali formata de volta pra DD/MM/AAAA no campo texto visível (que
    // continua digitável normalmente — o picker nunca abre sozinho por
    // foco/digitação, só pelo clique no ícone). Parametrizado pelos 3 ids
    // porque hoje existem dois campos de data no checkout (cartão e cadastro).
    function wireBirthdayDatePicker(toggleId, nativeId, textId) {
        var toggle      = el(toggleId);
        var nativeInput = el(nativeId);
        var textInput   = el(textId);
        if (!toggle || !nativeInput || !textInput) return;

        toggle.addEventListener('click', function (e) {
            e.preventDefault();
            nativeInput.value = parseBirthdayToIso(textInput.value);
            if (typeof nativeInput.showPicker === 'function') {
                try { nativeInput.showPicker(); } catch (err) { nativeInput.focus(); }
            } else {
                nativeInput.focus();
            }
        });

        nativeInput.addEventListener('change', function () {
            var parts = (nativeInput.value || '').split('-'); // AAAA-MM-DD
            if (parts.length !== 3) return;
            textInput.value = parts[2] + '/' + parts[1] + '/' + parts[0];
            textInput.dispatchEvent(new Event('input', { bubbles: true }));
        });
    }

    /* ─────────────────────────────────────────────
       RENDER: CAMPOS DE CARTÃO DE CRÉDITO
    ───────────────────────────────────────────── */
    function renderCardFields(opt) {
        // "cardWrap" é o .wscb-collapse (só controla a altura); o innerHTML e
        // os campos em si vivem em "cardInner" (padding/borda/grid) — padding
        // nunca pode ir no elemento com max-height:0, ver comentário grande em
        // .wscb-step-body-inner no checkout-base.css.
        var cardWrap  = el('ws-checkout-init-card-fields');
        var cardInner = el('ws-checkout-init-card-fields-inner');
        if (!cardWrap || !cardInner) return;

        if (opt.sub_type !== 'credit_card') {
            WsCheckoutBase.collapse(cardWrap);
            cardInner.innerHTML = '';
            return;
        }

        // Campos auto-preenchidos (ver AUTO_FILLED_CARD_FIELD_IDS) não aparecem
        // no formulário — são resolvidos internamente no submit.
        var visibleFields = (opt.fields || []).filter(function (f) {
            return !AUTO_FILLED_CARD_FIELD_IDS[f.id];
        });

        var fieldsHtml = visibleFields.map(function (f) {
            var colClass = (f.type === 'select') ? 'wscb-field ws-checkout-init-field--half' : 'wscb-field wscb-field--full';
            if (f.id === 'expiry_month' || f.id === 'expiry_year' || f.id === 'birthday_day' || f.id === 'expiry' || f.id === 'cvc') {
                colClass = 'wscb-field ws-checkout-init-field--half';
            }

            var inputHtml = '';
            if (f.type === 'select') {
                var opts = (f.options || []).map(function (o) {
                    return '<option value="' + escHtml(String(o.value || o)) + '">' + escHtml(String(o.label || o)) + '</option>';
                }).join('');
                inputHtml = '<select class="wscb-select" id="ws-checkout-init-card-' + f.id + '" data-attr="' + (f.data_attr || '') + '">' +
                    '<option value="">' + escHtml(f.label || '') + '</option>' + opts + '</select>';
            } else {
                inputHtml = '<input class="wscb-input" type="' + (f.type || 'text') + '" id="ws-checkout-init-card-' + f.id + '"' +
                    ' placeholder="' + escHtml(f.label || '') + '"' +
                    (f.maxlength ? ' maxlength="' + f.maxlength + '"' : '') +
                    ' data-attr="' + (f.data_attr || '') + '"' +
                    (f.required ? ' required' : '') + '>';

                // Ícone de calendário que abre o date picker NATIVO (showPicker(), ligado em
                // wireBirthdayDatePicker abaixo) — o input em si continua texto livre com
                // máscara DD/MM/AAAA, digitar nele nunca abre nada.
                if (f.id === 'birthday') {
                    inputHtml = '<div class="wscb-date-wrap">' + inputHtml +
                        '<button type="button" class="wscb-date-toggle" id="ws-checkout-init-card-birthday-toggle" aria-label="Abrir calendário">' +
                        '<span data-wsjs-icon="calendar"></span>' +
                        '</button>' +
                        '<input type="date" class="wscb-date-native" id="ws-checkout-init-card-birthday-native" tabindex="-1" aria-hidden="true">' +
                        '</div>';
                }
            }

            return '<div class="' + colClass + '">' +
                '<label class="wscb-label" for="ws-checkout-init-card-' + f.id + '">' + escHtml(f.label || '') + '</label>' +
                inputHtml +
                '</div>';
        }).join('');

        var installmentsHtml = '';
        if (opt.installments && opt.installments.length) {
            var installOpts = opt.installments.map(function (inst) {
                return '<option value="' + inst.quantity + '">' + escHtml(inst.label || '') + '</option>';
            }).join('');
            // Sem parcela pré-selecionada — força uma escolha explícita (mesmo
            // padrão do "Selecione..." do Gênero em initPersonalInfoStep) pra
            // evitar cliente comprando sem querer num número de parcelas que
            // não escolheu. Validado no clique de "Finalizar compra" (ver
            // initFinishButton).
            installmentsHtml = '<div class="wscb-field wscb-field--full ws-checkout-init-installments-wrap">' +
                '<label class="wscb-label">Parcelas</label>' +
                '<select class="wscb-select" id="ws-checkout-init-card-installments" required>' +
                '<option value="" disabled selected>Selecione...</option>' + installOpts + '</select>' +
                '</div>';
        }

        cardInner.innerHTML = fieldsHtml + installmentsHtml;

        // Trocar a parcela muda o total (desconto de 1x só na parcela 1, juros
        // nas demais) — o Resumo precisa acompanhar.
        var installSel = el('ws-checkout-init-card-installments');
        if (installSel) {
            installSel.addEventListener('change', function () {
                updatePaymentTotal((_initData && _initData.record && _initData.record.order && _initData.record.order.total) || 0);
            });
        }

        // Vincula máscara e validação a cada input
        var fieldMap = {};
        (opt.fields || []).forEach(function (f) { fieldMap[f.id] = f; });

        cardInner.querySelectorAll('input.wscb-input').forEach(function (input) {
            var fid  = (input.id || '').replace('ws-checkout-init-card-', '');
            var fdef = fieldMap[fid];
            if (!fdef) return;
            var dataType = fdef.data_type || fid;
            attachCardFieldEvents(input, getMask(dataType), fdef.regex || '');
        });

        wireBirthdayDatePicker('ws-checkout-init-card-birthday-toggle', 'ws-checkout-init-card-birthday-native', 'ws-checkout-init-card-birthday');

        // Os campos aparecem abaixo da forma de pagamento selecionada — em
        // telas menores (ou com muitas formas de pagamento na lista) eles
        // ficam fora da área visível e passam despercebidos. Rola até eles
        // assim que terminam de abrir (não antes: a posição/altura real só
        // existe depois da transição de abertura).
        WsCheckoutBase.expand(cardWrap, function () {
            cardWrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
    }

    /* ─────────────────────────────────────────────
       BRIDGE PARA SCRIPTS DE TOKENIZAÇÃO LEGADOS
       Gateways com script_token_url definem funções
       globais (ex: FuncaoTokenCardAppPgto_1) que
       leem campos com IDs do checkout antigo.
       Criamos esses campos como hidden inputs e
       sobrescrevemos FuncaoPagamentoAppsPgtoCartao
       para capturar o token e continuar o fluxo.
    ───────────────────────────────────────────── */
    function loadTokenScript(url) {
        return new Promise(function (resolve, reject) {
            if (_loadedScripts[url]) { resolve(); return; }
            var s    = document.createElement('script');
            s.src    = url;
            s.onload  = function () { _loadedScripts[url] = true; resolve(); };
            s.onerror = function () { reject(new Error('Falha ao carregar script de pagamento.')); };
            document.head.appendChild(s);
        });
    }

    // Contrato atual manda "script_token_url"; scriptTokenCard é suporte a
    // um contrato antigo que pode ainda aparecer em lojas não migradas.
    function getScriptTokenUrl(gw) {
        return (gw && (gw.script_token_url || gw.scriptTokenCard)) || '';
    }

    // Chave pública (RSA) de tokenização do cartão — vem em gateway_params da
    // forma de pagamento, resolvida pelo backend em /cart/checkout/init:
    // gateway_params.public_key (preferencial) ou gateway_params.param5
    // (mesmo valor, nome legado do mapeamento HD_PARAM4/HD_PARAM5 do
    // checkout-smart antigo). NUNCA gateway_params.param1 — esse é o
    // account_id ("ACCO_...") da conta Connect do gateway (PagSeguro/PagBank
    // v4 e integrações no mesmo padrão), não uma chave pública; mandar o
    // account_id pro token.js/encryptCard é exatamente o que gerava
    // "invalid `publicKey`" (INVALID_PUBLIC_KEY) reportado. param2/param3
    // (access_token/refresh_token OAuth) nunca são lidos aqui — são uso
    // server-side, o backend já os injeta sozinho no /cart/checkout/payment.
    function getPublicTokenizationParam(gw) {
        var gp = (gw && gw.gateway_params) || {};
        return gp.public_key || gp.param5 || '';
    }

    // A chave pública RSA real desse fluxo sempre começa com "MIIB" (cabeçalho
    // de uma chave em base64/DER, ~360+ caracteres) — se vier vazia ou com a
    // cara de um account_id ("ACCO_..."), é sinal de configuração incompleta
    // do gateway; aborta antes de chamar o script do gateway em vez de deixar
    // ele estourar um erro confuso lá na frente.
    function isValidPublicTokenizationKey(value) {
        var v = String(value || '').trim();
        if (!v || v.indexOf('ACCO_') === 0) return false;
        return v.indexOf('MIIB') === 0;
    }

    // Cada gateway lê a chave de um lugar: PagBank/PagSeguro (RSA "MIIB...")
    // vem em public_key/param5 → HD_PARAM5; Pagar.Me v5 manda o appId
    // público ("pk_...") em param4 e o token.js dele lê #HD_PARAM4_{fpg_id}.
    // A checagem RSA só vale quando o gateway manda public_key/param5 — antes
    // ela era exigida de todo gateway e barrava o Pagar.Me (que não tem
    // param5) com "Configuração de pagamento incompleta".
    function hasTokenizationKey(gw) {
        var gp = (gw && gw.gateway_params) || {};
        if (gp.public_key || gp.param5) return isValidPublicTokenizationKey(getPublicTokenizationParam(gw));
        return !!String(gp.param4 || '').trim();
    }

    // A API manda validade num único campo ("expiry", MM/AA ou MM/AAAA) —
    // só separamos em mês/ano aqui pros hidden inputs do script legado; o
    // payload da API em si continua com o valor original sem parse.
    function parseExpiry(value) {
        var m = String(value || '').trim().match(/^(0[1-9]|1[0-2])\/(\d{2}|\d{4})$/);
        if (!m) return null;
        return { month: m[1], year: m[2].length === 4 ? m[2].slice(2) : m[2] };
    }

    function bridgeLegacyFields(fpgId, gw, expiry) {
        var sfx = '_' + fpgId;

        function setHidden(id, value) {
            var inp = document.getElementById(id);
            if (!inp) {
                inp       = document.createElement('input');
                inp.type  = 'hidden';
                inp.id    = id;
                document.body.appendChild(inp);
            }
            inp.value = value || '';
        }

        setHidden('HD_PARAM4' + sfx, ((gw && gw.gateway_params) || {}).param4 || '');
        setHidden('HD_PARAM5' + sfx, getPublicTokenizationParam(gw));

        setHidden('Txt_AppsPgto_Nome'        + sfx, (el('ws-checkout-init-card-card_name')    || {}).value || '');
        setHidden('Txt_AppsPgto_Numero'      + sfx, ((el('ws-checkout-init-card-card_number') || {}).value || '').replace(/\D/g, ''));
        setHidden('Txt_AppsPgto_DataExp_Mes' + sfx, expiry.month);
        setHidden('Txt_AppsPgto_DataExp_Ano' + sfx, expiry.year);
        setHidden('Txt_AppsPgto_CodSeg'      + sfx, (el('ws-checkout-init-card-cvc')          || {}).value || '');
        setHidden('Txt_AppsPgto_CPF'         + sfx, onlyDigits((el('ws-checkout-init-card-cpf') || {}).value || ''));
        setHidden('HD_TOKEN_CARD'            + sfx, '');

        // Alvos vazios pros campos auto-preenchidos (ver AUTO_FILLED_CARD_FIELD_IDS)
        // — o script de tokenização do gateway (script_token_url) escreve neles
        // antes de chamar FuncaoPagamentoAppsPgtoCartao; doSubmit lê de volta.
        Object.keys(AUTO_FILLED_CARD_FIELD_IDS).forEach(function (fieldId) {
            setHidden('HD_' + fieldId.toUpperCase() + sfx, '');
        });
    }

    /* ─────────────────────────────────────────────
       CAPTCHA MODAL
    ───────────────────────────────────────────── */
    function openCaptchaModal(callback) {
        var modalEl = el('ws-checkout-init-captcha-modal');
        if (!modalEl) { callback(); return; }

        setMsg('ws-checkout-init-captcha-msg', '', '');
        modalEl.style.display = '';

        var continueBtn = el('ws-checkout-init-captcha-continue');

        function onContinue(e) {
            e.preventDefault();
            var token = (typeof grecaptcha !== 'undefined') ? grecaptcha.getResponse(_recaptchaWidgetId) : '';
            if (!token) {
                setMsg('ws-checkout-init-captcha-msg', 'Por favor, marque o reCAPTCHA.', 'error');
                return;
            }
            setMsg('ws-checkout-init-captcha-msg', '', '');
            if (continueBtn) continueBtn.removeEventListener('click', onContinue);
            modalEl.style.display = 'none';
            callback();
        }

        if (continueBtn) continueBtn.addEventListener('click', onContinue);

        var backdropEl = modalEl.querySelector('.ws-checkout-init-captcha-modal__backdrop');
        if (backdropEl) {
            backdropEl.addEventListener('click', function () {
                if (continueBtn) continueBtn.removeEventListener('click', onContinue);
                modalEl.style.display = 'none';
            }, { once: true });
        }
    }

    function requireCaptchaThenProceed(callback) {
        if (!_recaptchaEnabled || typeof grecaptcha === 'undefined') {
            callback();
            return;
        }
        var token = grecaptcha.getResponse(_recaptchaWidgetId);
        if (token) { callback(); return; }
        openCaptchaModal(callback);
    }

    /* ─────────────────────────────────────────────
       BOTÃO FINALIZAR
    ───────────────────────────────────────────── */
    function initFinishButton() {
        var btn = el('ws-checkout-init-btn-finish');
        if (!btn) return;

        btn.addEventListener('click', function () {
            if (!_selectedPayment) {
                wsMain.showAlert('Selecione uma forma de pagamento.', 'Atenção');
                return;
            }

            // Pedido sem frete não tem etapa de endereço — nada a exigir aqui
            // (collectAddress() já devolve null sem CEP).
            if (!_noShipping) {
                var recipientName = (el('ws-checkout-init-r-name') || {}).value || '';
                if (!recipientName.trim()) {
                    wsMain.showAlert('Informe o nome do destinatário.', 'Atenção');
                    return;
                }

                var recipientAddress = (el('ws-checkout-init-r-address') || {}).value || '';
                if (!recipientAddress.trim()) {
                    wsMain.showAlert('Informe o endereço de entrega.', 'Atenção');
                    return;
                }
            }

            // Cartão de crédito com opções de parcela: exige escolha explícita
            // (o <select> começa em "Selecione...", sem valor) — ver
            // renderCardFields. Evita concluir a compra com um número de
            // parcelas que o cliente não chegou a olhar/escolher.
            if (_selectedPayment.option.sub_type === 'credit_card' && _selectedPayment.option.installments && _selectedPayment.option.installments.length) {
                var installmentsSel = el('ws-checkout-init-card-installments');
                if (installmentsSel && !installmentsSel.value) {
                    wsMain.showAlert('Selecione o número de parcelas.', 'Atenção');
                    return;
                }
            }

            requireCaptchaThenProceed(function () {

            var labelEl = el('ws-checkout-init-finish-label');
            if (labelEl) labelEl.textContent = 'Aguarde...';
            btn.disabled = true;
            // Cobre a página inteira (não só o botão) até a confirmação: em
            // conexões lentas o resto da tela (outros campos, outras etapas
            // do acordeão) continuava clicável enquanto a compra processava,
            // dando margem pra ações duplicadas/concorrentes. Some sozinho em
            // qualquer saída de resetBtn() — sucesso (redireciona logo em
            // seguida) ou qualquer erro (tokenização, gateway, API, timeout).
            showOverlay();

            var opt   = _selectedPayment.option;
            var gw    = _selectedPayment.gateway;
            var fpgId = String(gw.id || '');

            function resetBtn() {
                btn.disabled = false;
                if (labelEl) labelEl.textContent = 'Finalizar compra';
                if (_recaptchaEnabled && typeof grecaptcha !== 'undefined') {
                    grecaptcha.reset(_recaptchaWidgetId);
                }
                hideOverlay();
            }

            function collectAddress() {
                var zip = ((el('ws-checkout-init-cep') || {}).value || '').replace(/\D/g, '');
                if (!zip) return null;
                return {
                    recipient:    (el('ws-checkout-init-r-name')         || {}).value || '',
                    zip_code:     zip,
                    street:       (el('ws-checkout-init-r-address')      || {}).value || '',
                    number:       (el('ws-checkout-init-r-number')       || {}).value || '',
                    complement:   (el('ws-checkout-init-r-complement')   || {}).value || '',
                    neighborhood: (el('ws-checkout-init-r-neighborhood') || {}).value || '',
                    city:         (el('ws-checkout-init-r-city')         || {}).value || '',
                    state:        (el('ws-checkout-init-r-state')        || {}).value || '',
                    country:      (el('ws-checkout-init-r-country')      || {}).value || 'Brasil'
                };
            }

            function doSubmit(cardToken) {
                flushNavigationHistory();

                var paymentMethod = {
                    fpg_id:    fpgId,
                    sub_type:  opt.sub_type || '',
                    subfpg_id: opt.subfpg_id || ''
                };

                if (opt.sub_type === 'credit_card') {
                    var installQty  = Number((el('ws-checkout-init-card-installments') || {}).value || 1);
                    var orderTotal  = (_initData && _initData.record && _initData.record.order && _initData.record.order.total) || 0;
                    paymentMethod.installments      = installQty;
                    // O backend repassa installment_total direto pro gateway
                    // (amount_with_interest) apagando "." e "," e lendo o resto
                    // como centavos — por isso string com 2 casas SEMPRE
                    // (123.4 viraria R$ 12,34; 100 viraria R$ 1,00). O valor é o
                    // total_value da parcela escolhida, igual ao checkout legado.
                    var selInst = getSelectedInstallment(opt);
                    var instTotal = (selInst && selInst.total_value > 0) ? selInst.total_value : orderTotal;
                    paymentMethod.installment_total = Number(instTotal).toFixed(2);

                    // card_token nunca vem em option.fields[] (o /init só declara
                    // os campos que o cliente digita) — sempre incluído à parte.
                    // Os demais campos vêm de option.fields[], dinamicamente: os
                    // "normais" (card_number, card_name, expiry, cvc, birthday,
                    // cpf, ou qualquer outro futuro) são lidos do input renderizado
                    // em renderCardFields; os auto-preenchidos (ver
                    // AUTO_FILLED_CARD_FIELD_IDS, ex: payment_method_id) são lidos
                    // do hidden HD_<ID_MAIUSCULO>_{fpg_id} escrito pelo script de
                    // tokenização do gateway (ver bridgeLegacyFields).
                    paymentMethod.fields = [{ id: 'card_token', value: cardToken || '' }].concat(
                        (opt.fields || []).map(function (f) {
                            var value = AUTO_FILLED_CARD_FIELD_IDS[f.id]
                                ? ((document.getElementById('HD_' + f.id.toUpperCase() + '_' + fpgId) || {}).value || '')
                                : ((el('ws-checkout-init-card-' + f.id) || {}).value || '');
                            return { id: f.id, value: value };
                        })
                    );
                }

                var captchaToken = '';
                if (_recaptchaEnabled && typeof grecaptcha !== 'undefined') {
                    captchaToken = grecaptcha.getResponse(_recaptchaWidgetId);
                }

                ApiWS.Calls.cartCheckoutPayment({
                    ct:            _ct,
                    ct2:           _ct2,
                    orderNumber:   _orderNumber,
                    address:       collectAddress(),
                    paymentMethod: paymentMethod,
                    orderRemarks:  (el('ws-checkout-init-obs') || {}).value || '',
                    captchaToken:  captchaToken
                })
                    .then(function (data) {
                        if (data && data.result === 'success') {
                            // Sem resetBtn() aqui de propósito — o loading (overlay + botão
                            // desabilitado) precisa continuar visível até a página realmente
                            // trocar pra /pedido-confirmado. Escondê-lo antes deixava o
                            // checkout "descoberto" e clicável de novo por um instante, entre
                            // a resposta da API e a navegação de fato acontecer.
                            var rec = data.record || {};
                            var qs  = '?ct=' + encodeURIComponent(_ct) +
                                      '&ct2=' + encodeURIComponent(_ct2) +
                                      '&order_number=' + encodeURIComponent(rec.order_number || _orderNumber);
                            window.location.href = '/pedido-confirmado' + qs;
                        } else {
                            resetBtn();
                            var apiMsg  = (data && data.message) || '';
                            var isAuth  = apiMsg.toLowerCase().indexOf('obrigat') !== -1 && apiMsg.toLowerCase().indexOf('ct') !== -1;
                            var msg     = isAuth
                                ? 'Sua sessão expirou ou você não está autenticado. Faça login novamente para finalizar o pedido.'
                                : (apiMsg || 'Não foi possível processar o pedido. Tente novamente.');
                            wsMain.showAlert(msg, isAuth ? 'Sessão inválida' : 'Atenção');
                        }
                    })
                    .catch(function () {
                        resetBtn();
                        wsMain.showAlert('Erro de conexão. Tente novamente.', 'Atenção');
                    });
            }

            function proceedToPayment() {
                // Gateway com script de tokenização legado
                var scriptTokenUrl = getScriptTokenUrl(gw);
                if (opt.sub_type === 'credit_card' && scriptTokenUrl) {
                    var expiry = parseExpiry((el('ws-checkout-init-card-expiry') || {}).value);
                    if (!expiry) {
                        resetBtn();
                        wsMain.showAlert('Informe uma validade de cartão válida no formato MM/AA.', 'Atenção');
                        return;
                    }

                    // Antes de sequer chamar o script do gateway: confere se a chave
                    // pública de tokenização veio configurada corretamente (ver
                    // getPublicTokenizationParam/isValidPublicTokenizationKey). Sem
                    // isso, o erro só aparecia lá na frente, vindo do gateway externo
                    // ("invalid `publicKey`"), sem contexto nenhum pro cliente.
                    if (!hasTokenizationKey(gw)) {
                        resetBtn();
                        wsMain.showAlert('Configuração de pagamento incompleta. Tente novamente mais tarde ou escolha outra forma de pagamento.', 'Atenção');
                        return;
                    }

                    bridgeLegacyFields(fpgId, gw, expiry);

                    // Evita processar callback/timeout duas vezes (script chamando
                    // duas vezes, ou callback chegando depois do timeout já ter disparado)
                    var settled = false;

                    var tokenTimer = setTimeout(function () {
                        if (settled) return;
                        settled = true;
                        resetBtn();
                        wsMain.showAlert('Tempo esgotado ao tokenizar o cartão. Tente novamente.', 'Atenção');
                    }, 30000);

                    // Captura o token após tokenização bem-sucedida
                    window.FuncaoPagamentoAppsPgtoCartao = function () {
                        if (settled) return;
                        settled = true;
                        clearTimeout(tokenTimer);
                        var tokenInp  = document.getElementById('HD_TOKEN_CARD_' + fpgId);
                        var cardToken = tokenInp ? tokenInp.value.trim() : '';
                        if (!cardToken) {
                            resetBtn();
                            wsMain.showAlert('O gateway não retornou o token do cartão.', 'Atenção');
                            return;
                        }
                        doSubmit(cardToken);
                    };

                    // Alguns scripts de tokenização (ex.: PagSeguro V4, token.js) só
                    // disparam o carregamento do SDK real do gateway (assets.pagseguro.com.br/...)
                    // de forma assíncrona, sem esperar por ele — e chamam a função de
                    // tokenização de qualquer forma assim que o próprio wrapper (pequeno,
                    // carrega quase instantâneo) termina de carregar. Isso é uma corrida
                    // que praticamente sempre perde na 1ª tentativa (o wrapper "termina" antes
                    // do SDK grande dele mesmo ter carregado): a função reporta erro via
                    // MostrarMsg com a mensagem padrão de ReferenceError do JS ("X is not
                    // defined" — ex.: "PagSeguro is not defined"), só porque a global do SDK
                    // ainda não existe. Como isso não é bug nosso (é externo, no script do
                    // gateway) mas o SDK normalmente já carregou por completo alguns
                    // instantes depois, tentamos de novo uma vez antes de mostrar erro pro
                    // cliente — sem isso ele sempre falhava e só funcionava no 2º clique.
                    var tokenizerRetried = false;

                    function runTokenizer() {
                        var tokenFuncStr = window['functionTokenCard_' + fpgId];
                        var fnMatch = (typeof tokenFuncStr === 'string')
                            ? tokenFuncStr.trim().match(/^([A-Za-z_$][\w$]*)\(\);?$/)
                            : null;
                        var tokenizer = fnMatch ? window[fnMatch[1]] : null;
                        if (typeof tokenizer !== 'function') {
                            throw new Error('O script não informou a função de tokenização.');
                        }
                        tokenizer();
                    }

                    // Intercepta erros do script legado (ex: cartão inválido)
                    window.MostrarMsg = function (data) {
                        if (settled) return;
                        var msg = (data && (data.mensagem_erro || data.message)) || 'Erro ao tokenizar cartão.';

                        if (!tokenizerRetried && /^[A-Za-z_$][\w$]*\s+is not defined$/i.test(String(msg || '').trim())) {
                            tokenizerRetried = true;
                            setTimeout(function () {
                                if (settled) return;
                                try { runTokenizer(); } catch (e) {
                                    if (settled) return;
                                    settled = true;
                                    clearTimeout(tokenTimer);
                                    resetBtn();
                                    wsMain.showAlert('Erro ao processar cartão.', 'Atenção');
                                }
                            }, 1500);
                            return;
                        }

                        settled = true;
                        clearTimeout(tokenTimer);
                        resetBtn();
                        wsMain.showAlert(msg, 'Atenção');
                    };

                    loadTokenScript(scriptTokenUrl)
                        .then(function () {
                            if (settled) return;
                            try {
                                runTokenizer();
                            } catch (e) {
                                if (settled) return;
                                settled = true;
                                clearTimeout(tokenTimer);
                                resetBtn();
                                wsMain.showAlert('Erro ao processar cartão.', 'Atenção');
                            }
                        })
                        .catch(function (e) {
                            if (settled) return;
                            settled = true;
                            clearTimeout(tokenTimer);
                            resetBtn();
                            wsMain.showAlert(e.message || 'Erro ao carregar módulo de pagamento.', 'Atenção');
                        });

                    return;
                }

                // Fluxo direto — sem tokenização legada
                doSubmit('');
            }

            // Cliente novo (identificação não encontrou o e-mail/CPF): cria a
            // conta antes de seguir com o pagamento.
            if (_needsSignup) {
                doSignupThenProceed(resetBtn, proceedToPayment);
            } else {
                proceedToPayment();
            }

            }); // requireCaptchaThenProceed
        });
    }

    /* ─────────────────────────────────────────────
       IDENTIDADE DO CLIENTE (p/ registro de navegação)
    ───────────────────────────────────────────── */
    function getCustomerIdentity() {
        var session       = (typeof ApiWS !== 'undefined' && ApiWS.User) ? ApiWS.User.getSession() : null;
        var hdId          = (el('HD_LVCLI_ID')    || {}).value || '';
        var hdEmail       = (el('HD_LVCLI_EMAIL') || {}).value || '';
        var guestIdentity = (el('ws-checkout-init-guest-identity') || {}).value || '';
        return {
            customerId:    Number((session && (session.id || session.customer_id)) || hdId) || 0,
            customerEmail: (session && session.email) || hdEmail || guestIdentity || ''
        };
    }

    function flushNavigationHistory() {
        try {
            var identity = getCustomerIdentity();
            ApiWS.Calls.cartCheckoutNavigation({
                cartToken:     _ct,
                customerId:    identity.customerId,
                customerEmail: identity.customerEmail,
                events:        ApiWS.Navigation.getAll()
            }).catch(function () { });
        } catch (e) { }
    }

    /* ─────────────────────────────────────────────
       STORE OPTIONS (observações + recaptcha)
    ───────────────────────────────────────────── */
    function initStoreOptions(storeOptions) {
        (storeOptions || []).forEach(function (opt) {
            if (opt.type === 'order_remarks' && opt.status) {
                var obsEl = el('ws-checkout-init-observations');
                if (obsEl) obsEl.style.display = '';

                var textarea = el('ws-checkout-init-obs');
                if (textarea && opt.info && opt.info.info_1) {
                    textarea.placeholder = opt.info.info_1;
                }

                var obsTrigger = el('ws-checkout-init-obs-trigger');
                if (obsTrigger) {
                    obsTrigger.addEventListener('click', function (e) {
                        e.preventDefault();
                        obsTrigger.style.display = 'none';
                        openCollapse('ws-checkout-init-obs-form');
                        if (textarea) textarea.focus();
                    });
                }
            }

            if (opt.type === 'google_recaptcha' && opt.status && opt.info) {
                initRecaptcha(opt.info.script_url, opt.info.site_key);
            }
        });
    }

    function initRecaptcha(scriptUrl, siteKey) {
        var container = el('ws-checkout-init-recaptcha');
        if (!container || !scriptUrl || !siteKey) return;

        _recaptchaEnabled = true;

        window._wsCheckoutRecaptchaLoad = function () {
            _recaptchaWidgetId = grecaptcha.render(container, { sitekey: siteKey });
        };

        var script = document.createElement('script');
        script.src = scriptUrl + '?onload=_wsCheckoutRecaptchaLoad&render=explicit';
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
    }

    /* ─────────────────────────────────────────────
       ACORDEÃO DE STEPS
    ───────────────────────────────────────────── */
    function initAccordion() {
        var container = accordionContainer();
        if (!container) return;

        // Step 1 já começa marcado wscb-expanded no HTML (ver markup) — falta
        // só abrir a altura do corpo, já que isso agora é controlado por JS
        // (WsCheckoutBase.expand/collapse), não mais só por CSS. Como a tela
        // ainda está display:none nesse ponto do fluxo, expand() detecta isso
        // (offsetParent === null) e aplica o estado final sem tentar animar.
        var openBody = container.querySelector('.wscb-step.wscb-expanded .wscb-step-body');
        if (openBody) WsCheckoutBase.expand(openBody);

        // Autoridade do estado de bloqueio: reaplica _unlockedUpTo no DOM (a
        // classe já vem certa no HTML pra não piscar, mas isso garante que os
        // dois nunca desalinhem, ex. se _unlockedUpTo já tiver avançado antes
        // de initAccordion() rodar — caso do cliente já identificado, ver
        // enterAccordionScreen).
        refreshStepLocks();

        container.querySelectorAll('.wscb-step-header').forEach(function (header) {
            header.addEventListener('click', function () {
                var stepEl   = header.closest('.wscb-step');
                var stepName = stepEl ? stepEl.getAttribute('data-step') : '';
                var stepIdx  = STEP_ORDER.indexOf(stepName);

                if (stepIdx > _unlockedUpTo) {
                    // A etapa que falta concluir é sempre a mais alta já
                    // liberada (_unlockedUpTo) — é ela que está "em aberto"
                    // (current step, ainda sem avançar), não a próxima da
                    // lista. Clicar em qualquer etapa futura aponta pra ela.
                    var pendingLabel = STEP_LABELS[STEP_ORDER[_unlockedUpTo]] || '';
                    wsMain.showAlert('Conclua primeiro a etapa "' + pendingLabel + '".', 'Atenção');
                    return;
                }

                if (stepName === 'shipping') {
                    var shipOptsEl = el('ws-checkout-init-shipping-options');
                    if (!shipOptsEl || !shipOptsEl.children.length) {
                        setMsg('ws-checkout-init-shipping-msg', 'Informe seu endereço na etapa anterior para ver as opções de frete.', 'info');
                    } else {
                        setMsg('ws-checkout-init-shipping-msg', '', '');
                    }
                }

                WsCheckoutBase.openStep(container, stepName);
            });
        });
    }

    /* ─────────────────────────────────────────────
       SIDEBAR STICKY ADAPTATIVO
    ───────────────────────────────────────────── */
    function initSidebarSticky() {
        var sidebar  = document.querySelector('.ws-checkout-init-sidebar');
        var content  = document.querySelector('.ws-checkout-init-sidebar__sticky');
        if (!sidebar || !content) return;

        var GAP = 16; // px abaixo do header

        function headerHeight() {
            var hdr = document.querySelector('#ws-carrinhoNovo header');
            return hdr ? hdr.offsetHeight : 0;
        }

        function update() {
            var h    = content.scrollHeight;
            var vh   = window.innerHeight;
            var hdrH = headerHeight();
            var topMin = hdrH + GAP;
            sidebar.style.top = (h + topMin + GAP <= vh)
                ? topMin + 'px'
                : Math.max(topMin, vh - h - GAP) + 'px';
        }

        window.addEventListener('resize', update);
        if (typeof ResizeObserver !== 'undefined') {
            new ResizeObserver(update).observe(content);
        }
        update();
    }

    /* ─────────────────────────────────────────────
       CUPOM DE DESCONTO
    ───────────────────────────────────────────── */
    function renderCoupon(cupom) {
        var savingsEl    = el('ws-checkout-init-savings');
        var savingsText  = el('ws-checkout-init-savings-text');
        var triggerEl    = el('ws-checkout-init-coupon-trigger');

        if (cupom && cupom.code) {
            if (savingsEl) {
                savingsEl.style.display = cupom.amount ? '' : 'none';
                if (savingsText && cupom.amount) {
                    savingsText.textContent = 'Você economizou ' + fmtPrice(cupom.amount) + ' com o cupom';
                }
            }
            if (triggerEl) triggerEl.style.display = 'none';
            closeCollapse('ws-checkout-init-coupon-form');
            var nameEl = el('ws-checkout-init-coupon-tag-name');
            var discEl = el('ws-checkout-init-coupon-tag-discount');
            var code   = String(cupom.code || cupom.name || '');
            if (nameEl) nameEl.textContent = code.charAt(0) === '#' ? code : ('#' + code);
            if (discEl) discEl.textContent = cupom.amount
                // Em cupom percentual a API manda o percentual efetivo (desconto /
                // subtotal * 100), que quase nunca é redondo (ex.: 12.496) —
                // arredonda pra inteiro aqui, o valor exato em R$ já aparece na
                // linha "Você economizou ...".
                ? (cupom.type === 'P' ? ('(-' + Math.round(cupom.amount) + '%)') : ('(-' + fmtPrice(cupom.amount) + ')'))
                : '';
            show('ws-checkout-init-coupon-applied');
        } else {
            if (savingsEl) savingsEl.style.display = 'none';
            if (triggerEl) triggerEl.style.display = '';
            closeCollapse('ws-checkout-init-coupon-form');
            var inp = el('ws-checkout-init-coupon-code');
            if (inp) inp.value = '';
            setMsg('ws-checkout-init-coupon-msg', '', '');
            hide('ws-checkout-init-coupon-applied');
        }
    }

    function initCoupon() {
        var triggerBtn = el('ws-checkout-init-coupon-trigger');
        if (triggerBtn) {
            triggerBtn.addEventListener('click', function (e) {
                e.preventDefault();
                triggerBtn.style.display = 'none';
                openCollapse('ws-checkout-init-coupon-form');
                var codeInput = el('ws-checkout-init-coupon-code');
                if (codeInput) codeInput.focus();
            });
        }

        var applyBtn = el('ws-checkout-init-coupon-apply');
        var removeBtn = el('ws-checkout-init-coupon-remove');
        var codeInp  = el('ws-checkout-init-coupon-code');

        if (applyBtn) {
            applyBtn.addEventListener('click', function () {
                var code = ((codeInp && codeInp.value) || '').trim();
                if (!code) {
                    setMsg('ws-checkout-init-coupon-msg', 'Informe o código do cupom.', 'error');
                    return;
                }
                setMsg('ws-checkout-init-coupon-msg', '', '');
                applyBtn.disabled = true;
                applyBtn.textContent = '...';
                showOverlay();

                ApiWS.Calls.cartCouponApply(code)
                    .then(function (data) {
                        applyBtn.disabled = false;
                        applyBtn.textContent = 'OK';

                        if (!data || data.result !== 'success') {
                            hideOverlay();
                            setMsg('ws-checkout-init-coupon-msg', (data && data.message) || 'Cupom inválido.', 'error');
                            return;
                        }

                        ApiWS.Calls.cartCheckoutClose(_ct)
                            .then(function () { return ApiWS.Calls.cartCheckoutInit(_ct, _ct2, _orderNumber); })
                            .then(function (d) { hideOverlay(); refreshCheckout(d); })
                            .catch(function () { hideOverlay(); });
                    })
                    .catch(function () {
                        applyBtn.disabled = false;
                        applyBtn.textContent = 'OK';
                        hideOverlay();
                        setMsg('ws-checkout-init-coupon-msg', 'Erro ao aplicar cupom. Tente novamente.', 'error');
                    });
            });
        }

        if (codeInp) {
            codeInp.addEventListener('keydown', function (e) {
                if (e.key === 'Enter' && applyBtn) applyBtn.click();
            });
        }

        if (removeBtn) {
            removeBtn.addEventListener('click', function () {
                removeBtn.disabled = true;
                showOverlay();

                ApiWS.Calls.cartCouponRemove()
                    .then(function () { return ApiWS.Calls.cartCheckoutClose(_ct); })
                    .then(function () { return ApiWS.Calls.cartCheckoutInit(_ct, _ct2, _orderNumber); })
                    .then(function (d) {
                        removeBtn.disabled = false;
                        hideOverlay();
                        refreshCheckout(d);
                    })
                    .catch(function () {
                        removeBtn.disabled = false;
                        hideOverlay();
                    });
            });
        }
    }

    /* ─────────────────────────────────────────────
       ENTRA NO ACORDEÃO DE CHECKOUT
       Compartilhado pelos dois caminhos que levam pra cá: cliente já
       logado (init(), customer vindo do /cart/checkout/init) e cliente
       novo (checkIdentityAndProceed(), quando check-signup não encontrou
       o e-mail/CPF digitado — nesse caso "record" é o mesmo _initData já
       carregado, só sem customer).
    ───────────────────────────────────────────── */
    function enterAccordionScreen(record, isKnownCustomer) {
        var cart     = (record && record.cart) || {};
        var customer = (record && record.customer) || {};
        var pmList   = record.payment_methods || [];
        var order    = record.order || {};
        var total    = order.total || 0;

        // Explícito (não vazio): o header trata a existência do input como um
        // override, então um valor vazio cairia em "0%" em vez de voltar
        // para os 67% de #HdEtapaLoja — ver comentário em setHeaderSubStage.
        setHeaderSubStage('FORMAS_PAGAMENTO');

        renderOrderDetails(cart, order);

        // Antes de renderPersonalInfoView (que já chama advanceToStep('address')
        // pro cliente identificado) — senão abriria a etapa de endereço.
        _noShipping = cart.sendable === false;
        if (_noShipping) applyNoShippingLayout();

        _needsSignup = !isKnownCustomer;
        if (_noShipping) {
            // Nada de endereço/frete pra carregar ou pré-calcular.
            if (isKnownCustomer) renderPersonalInfoView(customer);
            else renderPersonalInfoEditable(_identity);
        } else if (isKnownCustomer) {
            renderPersonalInfoView(customer);
            showAddressForm(); // troca pra lista assim que loadAddressList() resolver, se houver endereços
            loadAddressList(cart, customer);
        } else {
            renderPersonalInfoEditable(_identity);
            showAddressForm();
            tryPreFillAddress(cart, customer);
        }

        renderPaymentMethods(pmList, total);
        renderCoupon(cart.cupom);
        initStoreOptions(record.store_options);
        initPersonalInfoStep();
        initCepCalculator();
        initAddressStep();
        initAddressListStep();
        initShippingStep();
        initAccordion();
        initFinishButton();
        initCoupon();
        initProductsCard();
        initSidebarSticky();

        // Contador de caracteres do textarea de observações
        var obsTextarea = el('ws-checkout-init-obs');
        var obsCounter  = el('ws-checkout-init-obs-count');
        if (obsTextarea && obsCounter) {
            obsTextarea.addEventListener('input', function () {
                obsCounter.textContent = obsTextarea.value.length;
            });
        }

        show('ws-checkout-init-screen-checkout');
    }

    /* ─────────────────────────────────────────────
       INICIALIZAÇÃO PRINCIPAL
    ───────────────────────────────────────────── */
    function init() {
        parseParams();
        wsMain.tools.showLoading();

        if (!_ct) {
            wsMain.tools.hideLoading();
            show('ws-checkout-init-screen-error');
            var errEl = el('ws-checkout-init-error-text');
            if (errEl) errEl.textContent = 'Link inválido. Parâmetros de checkout ausentes.';
            return;
        }

        ApiWS.Calls.cartCheckoutInit(_ct, _ct2, _orderNumber)
            .then(function (data) {
                _initData = data;
                wsMain.tools.hideLoading();

                var record   = (_initData && _initData.record) || {};
                var customer = record.customer || {};

                var isLoggedIn = _initData && _initData.result === 'success' && !!customer.id;

                if (!isLoggedIn) {
                    initIdentifyScreen();
                    setHeaderSubStage('IDENTIFICACAO');
                    show('ws-checkout-init-screen-guest');
                    return;
                }

                enterAccordionScreen(record, true);
            })
            .catch(function (err) {
                console.error('[ws-checkout-payment-page]', err);
                wsMain.tools.hideLoading();
                show('ws-checkout-init-screen-error');
            });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
